
import React, { Component } from 'react'
import moment from 'moment'
import $ from 'jquery'
import { AppSettings, Storage, MessageText } from '../../configs'
import { connect } from 'react-redux'
import queryString from 'query-string'
import {
    SecureGateRoute,
    StatusIndicator,
    BreadCrumb,
    MainNotBotTabMenu,
    PODetail,
    MomDetail,
    DocumentModal,
    SearchEmployeeModal,
    ChooseMethodModal,
    RejectModal,
    AddItemModal,
    AddServiceItemModal,
    SearchCostCenterModal,
    ReleaseOrderModal,
    SearchPoModal,
    SubmitMethodModal,
    SubmitVerifyMethodModal,
    SubmitVerifyModal,
    RejectWithOptionModal,
} from "../../components"
import {
    clearPODetailAction,
    getPODetailAction,
    saveTransactionAction,
    rejectTransactionAction,
    updateStatusAction,
    updateVerifyAction,
} from '../../redux/actions/MainAction'
import {
    getSloc_WithPlantListAction,
    getBusinessInformationAction,
    getCostCenterAction,
    getValidateMatBatchFlagAction,
    getIOAction,
    getBudgetAction,
    getCostCenterActiveAction,
    getIOActiveAction
} from '../../redux/actions/MasterAction'
import {getIsAcceptAction,getIsPoAcceptAction} from '../../redux/actions/ApproveAction'
import { deleteFileAction, getFileAction } from '../../redux/actions/UploadAction'
import { msg } from '../../components/Notifications/MsgBox';
import { getYearEndPOListAction } from '../../redux/actions/ContractPOAction';
import { getChangeCommitteeAllAction } from '../../redux/actions/ChangeCommitteeAction'
import {
    getPaymentMethodAction,
    getPaymentSupplementAction,
    getPaymentTermAction,
    getVatAction,
    getRegionAction,
    getBankBranchAction,
    getCountryAction,
    getBankNameAction,
    getMasterVatAction,
    getVatCurrencyCodeAction,
    getMRFormAction,
    getMRVendorTypeAction,
    getMrRefListAction,
    getPOStatusAction,
    getUOMAction,
    getMRResonNotEvalAction,
    getMasterRejectOptionAction
}
    from '../../redux/actions/MasterAction'

import {
    startValidateTagsAction,
    addTagErrorAction,
    startLoadingAction,
    stopLoadingAction,
    clearStatusTabAction
}
    from '../../redux/actions/AppAction'
import {
    clearFileAction,
} from '../../redux/actions/UploadAction'

import {
    updateGR_ItemAction,
    updateGR_ServiceAction,
    updateGR_ServiceLineAction,
    updateGR_ServiceAccountAssignmentAction,
    updateGR_ItemAccountAssignmentAction
} from '../../redux/actions/GRAction'

import {
    START_VALIDATE_TAGS,
    ADD_TAG_ERROR,
    ERROR_401
} from '../../redux/actions/actionTypes'

import {
    data_status
} from '../../configs/datas'

import utilityHelper from '../../helpers/helperUtil'
import validateUtil from '../../helpers/validateUtil'

import '../../assets/css/rrs.css'
import tagsConfigHelper from '../../helpers/tagsConfigHelper'
import IdleTimer from 'react-idle-timer'
import {
    getSearchDirectoryInfoAwaitAction,
    
} from '../../redux/actions/MasterAction'
import { setStatusLockPOAction,setStatusUnlockPOAction } from '../../redux/actions/AppAction.js'
import { updateMR_IrDescriptionAction } from '../../redux/actions/MRAction'
import {
    clearSearchDirectoryInfoAction,
} from '../../redux/actions/MasterAction'
import {
    setKeyValueAction,
    clearModalAction
} from '../../redux/actions/ModalEmployeeAction'
import { getPo_ContarctAction } from '../../redux/actions/DocControlAction'
import ApproveRedux from '../../redux/reducers/ApproveRedux'
import { Tags_MR_ATTACHMENTS } from '../../configs/tagsConfig'

var base64 = require('base-64');
var utf8 = require('utf8');

class MainNotbotScreen extends Component {
    constructor(props) {
        super(props)

        this.state = {
            "status": "DRAFT",
            "header_text": "",
            "count_work": 1,
            "invoice_date": moment().format('YYYY-MM-DD'),
            "po_contract_create_by": "Demo User",
            "save_by": "Demo User",
            token: "",
            po_no: "3230025278",
            transaction_no: null,
            role: "",
            detail_result: [],
            doc_result: [],
            audit_data: [],
            employee_data: [],
            plant_data: [],
            business_area_data: [],
            gl_account_data: [],
            cost_center_data: [],
            asset_data: [],
            status_data: data_status,
            msgDialog: null,
            po_contract_no: "",
            masterRejectOption:[],
            // isAccept: false,
            // isPoAccept: false,
        }

        this.searchPO = this.searchPO.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.onHandleVerifySubmit = this.onHandleVerifySubmit.bind(this)
        this.getCurrentTransaction = this.getCurrentTransaction.bind(this)
        this.save = this.save.bind(this)
        this.saveSubmit = this.saveSubmit.bind(this)
        this.validateAllTab = this.validateAllTab.bind(this)
        this.validateMom = this.validateMom.bind(this)
        this.saveValidate = this.saveValidate.bind(this)
        this.handleMrIrDesCroptionChange = this.handleMrIrDesCroptionChange.bind(this)
        this.bindingMrIrDesCroption = this.bindingMrIrDesCroption.bind(this)
        this.handleReject = this.handleReject.bind(this)
        this.reject = this.reject.bind(this)
        this.checkAmount = this.checkAmount.bind(this)
        this.checkVerrifyCommitee = this.checkVerrifyCommitee.bind(this)
        this.delete_t_GR_ITEM = this.delete_t_GR_ITEM.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleValidate = this.handleValidate.bind(this)
        this.handleSubmitMethodModal = this.handleSubmitMethodModal.bind(this)
        this.handleSubmitVerifyMethodModal = this.handleSubmitVerifyMethodModal.bind(this)
        this.handleOnClickToExtendConsiderationPeriodItem = this.handleOnClickToExtendConsiderationPeriodItem.bind(this)
        this.checkIO = this.checkIO.bind(this)
        this.checkIOV2 = this.checkIOV2.bind(this)
        this.checkValidateIR = this.checkValidateIR.bind(this)
        this.validateGR = this.validateGR.bind(this)
        this.setReceiverName = this.setReceiverName.bind(this)
        this.handleRejectApprover = this.handleRejectApprover.bind(this)
        this.idleTimer = null
        this.pageTimeOut = 1000*60*15;
        this.onIdle = this._onIdle.bind(this)
        this.checkMatbatchflag = this.checkMatbatchflag.bind(this)
    }

    _onIdle(e) {
        //console.log('user is idle', e)
        if(window.$('#itemModal').length>0)
            window.$('#itemModal').modal('hide')
        if(window.$('#serviceLineModal').length>0)
            window.$('#serviceLineModal').modal('hide')
        if(window.$('#searchAssetModal').length>0)
            window.$('#searchAssetModal').modal('hide')
        if(window.$('#searchCostCenterModal').length>0)
            window.$('#searchCostCenterModal').modal('hide')
        if(window.$('#searchIOModal').length>0)
            window.$('#searchIOModal').modal('hide')
        if(window.$('#RejectModal').length>0)
            window.$('#RejectModal').modal('hide')
        if(window.$('#RejectWithOptionModal').length>0)
            window.$('#RejectWithOptionModal').modal('hide')            
        // if(window.$('#searchIRVendorModal').length>0)
        //     window.$('#searchIRVendorModal').modal('hide')
        // if(window.$('#searchVendorModal').length>0)
        //     window.$('#searchVendorModal').modal('hide')

        window.setClose();
        msg.hidewarningSave()

        
        const {history} = this.props
        history.push(AppSettings.defaultUrl)
    }

    async componentDidMount() {
        let { location, history, vats, bankBranchs, regions, countries, bankNames, unit_uom, payment_methods,
             payment_supplements, payment_terms, masterVats,masterRejectOption, currency_codes, mrForms, mrVendortypes ,mrReason } = this.props
        let{po_contract_no} = this.state;
        this.props.clearSearchDirectoryInfo();
        this.props.clearModal();
      
        const qs = queryString.parse(location.search)
        if (qs) {

            let { mode, po_no, transaction_no } = qs
            
            let text_transaction_no = ''
            let text_po_no = ''

            if (transaction_no) {
                let bytes_transaction_no = base64.decode(transaction_no);
                text_transaction_no = utf8.decode(bytes_transaction_no);
            }
            if (po_no) {
                let bytes_po_no = base64.decode(po_no);
                text_po_no = utf8.decode(bytes_po_no);
            }
            else if (this.props.po_contract_no !== "" && !transaction_no)            {
                
                text_po_no = this.props.po_contract_no;
            }

            this.props.clearStatusTab()

            //ถ้ามาจากหน้า MyTask
            if (mode) {
                this.props.clearPODetail()
                this.props.clearFile()
            }

            //ถ้าเป็นการเลือกรายการมาจากหน้า Task
            if (text_po_no) {
                await this.setState({
                    po_no: text_po_no,
                    transaction_no: text_transaction_no
                })
                this.searchPO(text_po_no, text_transaction_no, null)
                this.props.setUnlockPO();

            }

        }
        else //New
        {    
            this.props.setUnlockPO();
          //await this.searchPO(po_contract_no, null, null)
        }

        let addTagError = this.props.addTagError

        window.emitter.addListener(ADD_TAG_ERROR, function (tag) {
            // console.log("window.emitter.addListener(ADD_TAG_ERROR, function (tag)")
            // console.log(tag)
            addTagError(tag)
        })

        window.emitter.addListener(ERROR_401, function () {
            
            Storage.clear()
            
            history.push({
                pathname: AppSettings.loginUrl,
                params: `?mode=logout`,
            })
        })

        // if (!payment_methods || !payment_methods.length) {
        //     this.props.getPaymentMethod()
        // }
        // if (!payment_supplements || !payment_supplements.length) {
        //     this.props.getPaymentSupplement()
        // }
        // if (!payment_terms || !payment_terms.length) {
        //     this.props.getPaymentTerm()
        // }
        // this.props.getPlantInfo()
        // if (!vats || !vats.length) {
        //     this.props.getVat()
        // }
        // if (!regions || !regions.length) {
        //     this.props.getRegion()
        // }
        // if (!bankBranchs || !bankBranchs.length) {
        //     this.props.getBankBranch()
        // }
        // if (!countries || !countries.length) {
        //     this.props.getCountry()
        // }
        // if (!bankNames || !bankNames.length) {
        //     this.props.getBankName()
        // }
        // if (!masterVats || !masterVats.length) {
        //     //this.props.getMasterVat()
        // }
        if (!masterRejectOption || !masterRejectOption.length) {
            this.props.getMasterRejectOption()
        }
        // if (!currency_codes || !currency_codes.length) {
        //     this.props.getVatCurrencyCode()
        // }

        let isCallMR = false
        if(mrForms.length >0){
            if(mrForms[0].iS_ENERGY === undefined || mrForms[0].iS_SEPARATION_PLANT === undefined){
                isCallMR=true;
            }
        }

        // if ((!mrForms || !mrForms.length)|| isCallMR)  {
        //     this.props.getMRForm()
        // }
        if (!mrVendortypes || !mrVendortypes.length) {
            //this.props.getMRVendorType()
        }
        
        // if (!unit_uom || !unit_uom.length) {
        //     this.props.getUOM()
        // }

        this.props.getUOM()

        if (!mrReason || !mrReason.length) {
            this.props.getMRResonNotEval();
        }
        
        $(function () {
            window.onComponentDidMount()
        })
    }

    async searchPO(po_no, transaction_no, actiontype) {
        let promise=new Promise(async (resolve,reject)=>{
            let unitCode=null
            let employeePIS =Storage.getEmployeePIS()
            let user= Storage.getUser()
    
            if (!employeePIS) {
                // msg.error("ไม่พบข้อมูลผู้ใช้งานนี้ บนระบบส่วนงานบุคคล PIS!")
                // return
                unitCode = user.unitCode
            }
            else {
                unitCode = employeePIS.departmentCode
            }

            this.props.clearPODetail()

            await this.props.getPODetail(po_no, transaction_no, unitCode, actiontype,user.userName,this.props.sessionNo,employeePIS.employeeNameTH).then(response => {
                const transaction = response.data
                const isSuccess = transaction.returnData.isSuccess === true
                let returnMessage = transaction.returnData.returnMessage
                const errMessage = transaction.returnData.errMessage

                console.log('this.props.transaction')
             

                if (!isSuccess && !returnMessage) {
                    returnMessage = "ไม่สามารถเชื่อมต่อเซิร์ฟเวอร์ได้"
                }

                if (!isSuccess) {
                    //fail
                    msg.error(returnMessage)
                    if (errMessage) console.error("MainScreen.searchPO()", errMessage)
                    reject(errMessage)
                }
                else {
                    //success
                    let purOrg = transaction.t_PO_DETAIL.puR_CH_ORG
                    let plants = transaction.t_GR_ITEM.map(f => f.plant)

                    // console.log('this.props.transaction')
                    // console.log(transaction)
                    // console.log(plants)

                    if (actiontype != "save") {
                        //this.props.getSloc_WithPlantList(purOrg, plants)
                        //this.props.getMrRefList(po_no, transaction_no)
                    }
                    this.props.setUnlockPO();
                    resolve(transaction)
                }


            }).catch(error => {
                if (error.message) {
                    
                    if (error.message.indexOf("timeout") > -1) {
                        msg.error("เชื่อมต่อ Server เกินกว่าเวลาที่กำหนด กรุณาตรวจสอบการเชื่อมต่อ")
                    }
                    else {
                        msg.error(error.message)
                    }
                   
                    reject(error.message)
                }
                else {
                    reject("searchPO error")
                }

            })

        })

        return promise
    }

    validateGR(type) {
        let errors = []
        const {
            t_GR_DETAIL,
            t_GR_ITEM,
            t_GR_ITEM_ACCOUNT_ASSIGNMENT,
            t_GR_SERVICE,
            t_GR_SERVICELINE,
            t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT,
            t_IR_DETAIL,
            t_IR_ITEM,
            t_IR_ITEM_ACCOUNT_ASSIGNMENT,
            t_MR_DETAIL,
            t_MR_ATTACHMENTS,
            t_MR_VENDOR
        } = this.props

        switch (type) {
            case "GR":
                tagsConfigHelper.validate_GR({
                    t_GR_DETAIL: t_GR_DETAIL,
                    t_GR_ITEM: t_GR_ITEM,
                    t_GR_ITEM_ACCOUNT_ASSIGNMENT: t_GR_ITEM_ACCOUNT_ASSIGNMENT,
                    t_GR_SERVICE: t_GR_SERVICE,
                    t_GR_SERVICELINE: t_GR_SERVICELINE,
                    t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT: t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT
                })
                break
            case "ItemModal" :
                tagsConfigHelper.validate_ItemModal({
                    t_GR_ITEM : t_GR_ITEM,
                    t_GR_ITEM_ACCOUNT_ASSIGNMENT : t_GR_ITEM_ACCOUNT_ASSIGNMENT,
                    t_GR_SERVICE  : t_GR_SERVICE,
                    t_GR_SERVICELINE : t_GR_SERVICELINE,
                    t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT : t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT  
                })
                break
             case "ServiceLineModal" :
                tagsConfigHelper.validate_ServiceLineModal({
                    t_GR_SERVICELINE : t_GR_SERVICELINE,
                    t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT : t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT  
                })
                break
            case "IR":
                tagsConfigHelper.validate_IR({
                    t_IR_DETAIL : t_IR_DETAIL,
                    t_IR_ITEM : t_IR_ITEM,
                    t_IR_ITEM_ACCOUNT_ASSIGNMENT : t_IR_ITEM_ACCOUNT_ASSIGNMENT
                })
                break
            // case "MR":
            //     tagsConfigHelper.validate_MR({
            //         t_MR_DETAIL: t_MR_DETAIL,
            //         t_MR_ATTACHMENTS: t_MR_ATTACHMENTS,
            //         t_MR_VENDOR: t_MR_VENDOR
            //     })
            //     break
            case "MOM":
                tagsConfigHelper.validate_MOM({
                    t_MR_DETAIL: t_MR_DETAIL,
                    t_MR_ATTACHMENTS: t_MR_ATTACHMENTS,
                    t_MR_VENDOR: t_MR_VENDOR
                })
                break
        }

    }

    async handleDelete(item_name, data) {
        switch (item_name) {
            case "t_GR_ITEM":
                this.delete_t_GR_ITEM(data)
                return;
            case "t_GR_SERVICE":
                this.delete_t_GR_SERVICE(data)
                return;
            case "t_GR_SERVICELINE":
                this.delete_t_GR_SERVICELINE(data)
                return;
            case "t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT":
                this.delete_t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT(data)
                return;
            case "Transaction":
                this.delete_Transaction()
                return;
            default:

                return;

        }
    }

    async delete_Transaction() {
        console.log("delete_Transaction");

        const title = "Confirm"
        const confirmText = MessageText.APP.POPUP_MSG_CONFIRM_DELETE_MOM

        msg.showConfirm(
            title,
            confirmText,
            () => {
                msg.hideConfirm()
                //delete
                const {
                    transaction_no,
                    updateStatus,
                    history
                } = this.props

                let User = Storage.getUser();
                

                //updateGR_Item(item_new, "", "", true);
                updateStatus(transaction_no, "DELE", User.username).then((response) => {

                    const isSuccess = response.data.success
                    const returnMessage = response.data.message


                    if (isSuccess) {
                        msg.success(MessageText.APP.POPUP_MSG_SUCCESS_DELETE_MOM)
                        history.push(AppSettings.defaultUrl)
                    } else {
                        msg.error(returnMessage)
                    }
                })

            },
            () => {
                msg.hideConfirm()
                console.log("On Cancel")
            },
            () => {
                console.log("On Closed")
            }
        )
    }

    async delete_t_GR_ITEM(data) {
        console.log("delete_t_GR_ITEM");

        const title = "Confirm"
        const confirmText = MessageText.PAGE.GR.POPUP_MSG_CONFIRM_DELETE_GR_ITEM

        msg.showConfirm(
            title,
            confirmText,
            () => {
                msg.hideConfirm()
                //delete
                const {
                    t_GR_ITEM,
                    updateGR_Item,
                    t_GR_ITEM_ACCOUNT_ASSIGNMENT,
                    updateGR_ItemAccountAssignment
                } = this.props
                let item_curent = t_GR_ITEM;
                let item_new = [];

                item_curent.forEach(function (element) {
                    
                    if (element.item_no != data.item_no) {
                        //console.log(element);
                        item_new.push(element)
                    }
                });

                let item_account_assigment_new = [];
                t_GR_ITEM_ACCOUNT_ASSIGNMENT && t_GR_ITEM_ACCOUNT_ASSIGNMENT.forEach(function (element) {
                    if (element.item_no + "" !== data.item_no + "") {
                        //console.log(element);
                        item_account_assigment_new.push(element)
                    }
                });

                
                updateGR_Item(item_new, "", "", true);
                updateGR_ItemAccountAssignment(item_account_assigment_new, "", "", true)

            },
            () => {
                msg.hideConfirm()
                console.log("On Cancel")
            },
            () => {
                console.log("On Closed")
            }
        )
    }

    async delete_t_GR_SERVICE(data) {
        console.log("delete_t_GR_SERVICE");

        const title = "Confirm"
        const confirmText = MessageText.PAGE.GR.POPUP_MSG_CONFIRM_DELETE_GR_SERVICE
        msg.showConfirm(
            title,
            confirmText,
            () => {
                msg.hideConfirm()
                //delete
                const {
                    t_GR_SERVICE,
                    t_GR_SERVICELINE,
                    t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT,
                    updateGR_Service,
                    updateGR_ServiceLine,
                    updateGR_ServiceAccountAssignment
                } = this.props
                let item_curent = t_GR_SERVICE;
                let item_new = [];

                item_curent.forEach(function (element) {
                    if (element.service_item_no != data.service_item_no) {
                        //console.log(element);
                        item_new.push(element)
                    }
                });

                // console.log(data);
                // console.log("item_curent");
                // console.log(item_curent);
                // console.log("item_new");
                // console.log(item_new);

                let serviceline_new = [];
                t_GR_SERVICELINE.forEach(function (element) {
                    if (element.service_item_no != data.service_item_no) {
                        //console.log(element);
                        serviceline_new.push(element)
                    }
                });


                let serviceline_account_assigment_new = [];
                t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT.forEach(function (element) {
                    if (element.item_no != data.service_item_no) {
                        //console.log(element);
                        serviceline_account_assigment_new.push(element)
                    }
                });

                updateGR_Service(item_new, "", "", true);
                updateGR_ServiceLine(serviceline_new, "", "", true);
                updateGR_ServiceAccountAssignment(serviceline_account_assigment_new, "", "", true);

                window.onDeleteServiceItem(data)
            },
            () => {
                msg.hideConfirm()
                console.log("On Cancel")
            },
            () => {
                console.log("On Closed")
            }
        )
    }

    async delete_t_GR_SERVICELINE(data) {
        console.log("delete_t_GR_SERVICELINE");

        const title = "Confirm"
        const confirmText = MessageText.PAGE.GR.POPUP_MSG_CONFIRM_DELETE_GR_SERVICE_LINE

        msg.showConfirm(
            title,
            confirmText,
            () => {
                msg.hideConfirm()
                //delete
                const {
                    t_GR_SERVICELINE,
                    t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT,
                    updateGR_ServiceLine,
                    updateGR_ServiceAccountAssignment
                } = this.props



                let serviceline_new = [];
                t_GR_SERVICELINE.forEach(function (element) {
                    if (element.service_line_no + "" !== data.service_line_no + "" || element.service_item_no != data.service_item_no) {
                        serviceline_new.push(element)
                    }
                });

                t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT.map((item, _index) => {
                    if (item.service_line_no + "" == data.service_line_no + "" && item.item_no == data.service_item_no) {
                        item.checked = false
                    }
                })

/*                 let serviceline_account_assigment_new = [];
                t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT.forEach(function (element) {
                    if (element.service_line_no + "" !== data.service_line_no + "" || element.item_no !== data.service_item_no) {
                        serviceline_account_assigment_new.push(element)
                    }
                });
 */
                // console.log(serviceline_new);
                // console.log(serviceline_account_assigment_new);
                updateGR_ServiceLine(serviceline_new, "", "", true);
                //updateGR_ServiceAccountAssignment(serviceline_account_assigment_new, "", "", true);

                window.onDeleteServiceLine(serviceline_new)
            },
            () => {
                msg.hideConfirm()
                console.log("On Cancel")
            },
            () => {
                console.log("On Closed")
            }
        )
    }

    async delete_t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT(data) {
        console.log("delete_t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT");

        const title = "Confirm"
        const confirmText = MessageText.PAGE.GR.POPUP_MSG_CONFIRM_DELETE_GR_SERVICE_LINE_ACC

        msg.showConfirm(
            title,
            confirmText,
            () => {
                msg.hideConfirm()
                //delete
                const {
                    t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT,
                    updateGR_ServiceAccountAssignment
                } = this.props


                //console.log(data);
                //console.log(t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT);
                let serviceline_account_assigment_new = [];
                t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT.forEach(function (element) {
                    if (element.acc_id != data.acc_id || element.service_line_no != data.service_line_no || element.item_no != data.item_no) {
                        serviceline_account_assigment_new.push(element)
                    }
                });

                //console.log(serviceline_account_assigment_new);
                updateGR_ServiceAccountAssignment(serviceline_account_assigment_new, "", "", true);


            },
            () => {
                msg.hideConfirm()
                console.log("On Cancel")
            },
            () => {
                console.log("On Closed")
            }
        )
    }

    getCurrentTransaction() {

        const {
            transaction,
            t_HEADER,
            t_PO_DETAIL,
            t_PO_COMMITTEE,
            t_GR_DETAIL,
            t_GR_ITEM,
            t_GR_ITEM_ACCOUNT_ASSIGNMENT,
            t_GR_SERVICE,
            t_GR_SERVICELINE,
            t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT,
            t_IR_DETAIL,
            t_IR_ITEM,
            t_IR_ONE_TIME_VENDOR,
            t_IR_ITEM_ACCOUNT_ASSIGNMENT,
            t_IR_SERVICELINE,
            t_MR_DETAIL,
            t_MR_VENDOR,
            t_MR_ATTACHMENTS,
            t_NEW_ASSET,
            t_MR_IR_DESCRIPTION,
            t_IR_TAXS,
            t_MR_EVAL,
            upload_files,
            temp_trans_att_no
        } = this.props


        let model = transaction

        model.t_HEADER = t_HEADER
        model.t_PO_DETAIL = t_PO_DETAIL
        model.t_PO_COMMITTEE = t_PO_COMMITTEE
        model.t_GR_DETAIL =                            null //t_GR_DETAIL
        model.t_GR_ITEM =                              null //t_GR_ITEM
        model.t_GR_ITEM_ACCOUNT_ASSIGNMENT =           null //t_GR_ITEM_ACCOUNT_ASSIGNMENT
        model.t_GR_SERVICE =                           null //t_GR_SERVICE
        model.t_GR_SERVICELINE =                       null //t_GR_SERVICELINE
        model.t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT =    null //t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT
        model.t_IR_DETAIL =                            null //t_IR_DETAIL
        model.t_IR_ITEM =                              null //t_IR_ITEM
        model.t_IR_ONE_TIME_VENDOR =                   null //t_IR_ONE_TIME_VENDOR
        model.t_IR_ITEM_ACCOUNT_ASSIGNMENT =           null //t_IR_ITEM_ACCOUNT_ASSIGNMENT
        model.t_IR_SERVICELINE =                       null //t_IR_SERVICELINE
        model.t_MR_DETAIL = t_MR_DETAIL
        model.t_MR_VENDOR = t_MR_VENDOR
        model.t_MR_ATTACHMENTS = t_MR_ATTACHMENTS
        model.t_NEW_ASSET = t_NEW_ASSET
        model.t_MR_IR_DESCRIPTION = t_MR_IR_DESCRIPTION
        model.t_IR_TAXS = null //t_IR_TAXS
        model.t_MR_EVAL = null //t_MR_EVAL
        model.temp_trans_att_no = temp_trans_att_no
        
        

        return model
    }

    async handleSubmit(event, source, isSubmit, status, nexttab) {
        event.preventDefault()
        let msgDialog = { title: 'Confirm', text: MessageText.APP.POPUP_MSG_CONFIRM_SAVE }
        if (source.props.tabName === 'PO') {
            msgDialog.text = MessageText.PAGE.PO.POPUP_MSG_CONFIRM_SAVE
        }
        else if (source.props.tabName === 'MO') {
            msgDialog.text = MessageText.PAGE.MO.POPUP_MSG_CONFIRM_SAVE
        }
        // else if (source.props.tabName === 'IR') {
        //     msgDialog.text = MessageText.PAGE.IR.POPUP_MSG_CONFIRM_SAVE
        // }
        // else if (source.props.tabName === 'MR' && isSubmit) {
        //     msgDialog.text = MessageText.PAGE.MR.POPUP_MSG_CONFIRM_SUBMIT
        // }
        // else if (source.props.tabName === 'MR' && !isSubmit) {
        //     msgDialog.text = MessageText.PAGE.MR.POPUP_MSG_CONFIRM_SAVE
        // }
        else if (source.props.tabName === 'CMD') {
            msgDialog.text = MessageText.PAGE.MR.POPUP_MSG_CONFIRM_CHOOSE_METHOD
        }
        await this.setState({ msgDialog: msgDialog })
        
        this.saveValidate(status,source.props.tabName,nexttab,isSubmit,this.props.isAccept,this.props.isPoAccept)
        
    }

    async handleSubmitVerify(event) {

    }

    async onHandleVerifySubmit(message_to_committee){
        let {t_HEADER,updateVerify,history} = this.props
        updateVerify(t_HEADER.transaction_no,message_to_committee).then((response) => {
            //let isSuccess = response.data.returnData.isSuccess === true
            history.push(AppSettings.defaultUrl)
        })
    }

    async handleReject(Reject_Result, Reject_By,Reject_Option,Reject_Option_Desc) {

        this.reject(Reject_Result, Reject_By,Reject_Option,Reject_Option_Desc)
    }

    async handleRejectApprover(obj , event , Reject_Result, Reject_By,Reject_Option,Reject_Option_Desc) {

        const {
            t_PO_DETAIL,
        } = this.props
        t_PO_DETAIL.Reject_Option = Reject_Option
        t_PO_DETAIL.Reject_By = Reject_By
        t_PO_DETAIL.Reject_Result = Reject_Result
        t_PO_DETAIL.Reject_Option_Desc = Reject_Option_Desc
        this.handleSubmit(event, obj, true,'REJT')
        //this.reject(Reject_Result, Reject_By,Reject_Option)
    }


    async reject(Reject_Result, Reject_By,Reject_Option,Reject_Option_Desc) {
        await this.props.startLoading()

        const {
            rejectTransaction,
            history
        } = this.props

        const transaction = this.getCurrentTransaction()

        // const searchPO = this.searchPO

        const title = "Confirm"
        const confirmText = MessageText.APP.POPUP_MSG_CONFIRM_REJECT

        msg.showConfirm(
            title,
            confirmText,
            () => {
                msg.hideConfirm()

                rejectTransaction(transaction, Reject_Result, Reject_By,Reject_Option,Reject_Option_Desc).then((response) => {

                    const isSuccess = response.data.isSuccess
                    const returnMessage = response.data.returnMessage
                    const errMessage = response.data.errMessage
                    // let poNo = transaction.t_PO_DETAIL.po_contract_no
                    // let tranNo = transaction.t_PO_DETAIL.transaction_no

                    this.props.stopLoading()
                    if (isSuccess) {
                        msg.success(returnMessage)
                        history.push(AppSettings.defaultUrl)
                    } else {
                        msg.error(returnMessage)
                        if (errMessage) console.error("MainScreen.reject()", errMessage)
                    }
                })
            },
            () => {
                msg.hideConfirm()
                this.props.stopLoading()
                console.log("On Cancel")
            },
            () => {
                this.props.stopLoading()
                console.log("On Closed")
            }
        )
    }

    async save(status = null, source, nexttab) {
        await this.props.startLoading()
        const {
            saveTransaction,
        } = this.props
        const{
            sessionNo
        } = this.props;
        let errors = []

        const user = Storage.getUser()
        const role = Storage.getRole()


        const searchPO = this.searchPO
        const transaction = this.getCurrentTransaction()

        const title = this.state.msgDialog.title
        const confirmText = this.state.msgDialog.text

        if (source.props.tabName === 'GR') {
            let _checkIO = await this.checkIO()
            if (_checkIO !== null) {
                errors.push(_checkIO)
            }

        }

        let error_messages = []

        if (errors.length > 0) {
            errors.forEach((error, index) => {
                error_messages.push(error.error_message)
            })
            this.props.stopLoading()
            msg.error(error_messages.join('<br/>'))
        } else {

            msg.showConfirm(
                title,
                confirmText,
                () => {
                    msg.hideConfirm()
                    console.log("On save save")
                    
                    saveTransaction(false, transaction, user.userName, role, status, null, sessionNo).then((response) => {
                        const isSuccess = response.data.returnData.isSuccess === true
                        let returnMessage = response.data.returnData.returnMessage
                        const errMessage = response.data.returnData.errMessage
                        const poNo = response.data.t_PO_DETAIL.po_contract_no
                        const tranNo = response.data.returnData.transactionNo

                       // returnMessage = returnMessage + '<br/>เลขที่เอกสาร/MOM Doc No. : ' + response.data.t_HEADER.doc_no
                        returnMessage = returnMessage + '<br/>เลขที่เอกสาร/MOM Doc No. : ' + response.data.t_HEADER.mom_no

                        this.props.stopLoading()
                        if (isSuccess) {
                            msg.success(returnMessage, nexttab)
                             window.onLoadServiceLineBySave(this.props.t_GR_SERVICELINE)
                            //  searchPO(poNo, tranNo, "save").then((response)=>{
                            //      window.onLoadServiceLineBySave(response.t_GR_SERVICELINE)
                            //  })
                           
                        } else {
                            msg.error(returnMessage)
                            if (errMessage) console.error("MainScreen.save()", errMessage)
                        }
                    })
                },
                () => {
                    this.props.stopLoading()
                    msg.hideConfirm()
                    console.log("On Cancel")
                },
                () => {
                    this.props.stopLoading()
                    console.log("On Closed")
                }
            )
        }

    }

    async saveSubmit(status = null) {
        this.props.startLoading()
        const user = Storage.getUser()
        const role = Storage.getRole()

        await this.props.startValidateTags()
        window.emitter.emit(START_VALIDATE_TAGS, '')

        const {
            history,
            tagErrors,
            saveTransaction,
            sessionNo
        } = await this.props
        
        const {
            t_GR_ITEM,
            t_GR_SERVICE,
            t_GR_SERVICELINE,
            t_GR_ITEM_ACCOUNT_ASSIGNMENT,
            t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT,
            t_PO_DETAIL,
            t_IR_ONE_TIME_VENDOR,
            t_HEADER
        } = this.props
        let po_no = t_PO_DETAIL && t_PO_DETAIL.po_contract_no;

        const transaction = this.getCurrentTransaction()
        const title = this.state.msgDialog.title
        const confirmText = this.state.msgDialog.text

        let _check = this.checkAmount()
        if (_check !== null) {
            tagErrors.push(_check)
        }

        let _checkEval = this.checkEval()
        if (_checkEval !== null) {
            tagErrors.push(_checkEval)
        }

        let _checkFineOver = this.checkFineOver()
        if (_checkFineOver !== null) {
            tagErrors.push(_checkFineOver)
        }

        let _checCompleteDate = this.checkCompleteDate()
        if (_checCompleteDate !== null) {
            tagErrors.push(_checCompleteDate)
        }

        let _checkTotal = validateUtil.checkTotalReceiveVal(t_GR_SERVICE, t_GR_SERVICELINE)
        if (_checkTotal !== null) {
            tagErrors.push(_checkTotal)
        }

        let _checkQty = validateUtil.checkReceiveQty(t_GR_ITEM, t_GR_SERVICE, t_GR_SERVICELINE, po_no)
        if (_checkQty !== null) {
            tagErrors.push(_checkQty)
        }

        let _checkGoodsRecipient = validateUtil.checkGoodsRecipientVal(t_GR_ITEM)
        if (_checkGoodsRecipient !== null) {
            tagErrors.push(_checkGoodsRecipient)
        }

        if (role === 'R') {
            let _checkDummyAssect = validateUtil.checkDummyAssect(t_GR_ITEM, t_GR_SERVICE, t_GR_SERVICELINE, t_GR_ITEM_ACCOUNT_ASSIGNMENT, t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT)
            if (_checkDummyAssect !== null) {
                tagErrors.push(_checkDummyAssect)
            }
        }

        let _checkSelectItem = validateUtil.checkSelectItem(t_GR_ITEM, t_GR_SERVICE, t_GR_SERVICELINE)
        if (_checkSelectItem !== null) {
            tagErrors.push(_checkSelectItem)
        }

        let _checkIO = this.checkIO()
        if (_checkIO !== "") {
            //tagErrors.push("งบประมานไม่เพียงพอ หมายเลขงบประมาน " + _checkIO)
        }

        let _validateIR = this.checkValidateIR()
        if (_validateIR !== null) {
            tagErrors.push(_validateIR)
        }


        setTimeout(function () {
            // console.log("tagErrors:")
            // console.log(tagErrors)
            let error_messages = []

            if (tagErrors.length > 0) {
                tagErrors.forEach((error, index) => {
                    error_messages.push(error.error_message)
                })
                msg.error(error_messages.join('<br/>'))
                //this.props.stopLoading()
            } else {

                msg.showConfirm(
                    title,
                    confirmText,
                    () => {
                        msg.hideConfirm()
                        console.log("On save")
                        
                        saveTransaction(true, transaction, user.userName, role, status , null , sessionNo).then((response) => {

                            let isSuccess = response.data.returnData.isSuccess === true
                                                   // returnMessage = returnMessage + '<br/>เลขที่เอกสาร/MOM Doc No. : ' + response.data.t_HEADER.doc_no
                                                   let returnMessage = ""
                            if (status === "ACCEPT")  {     
                                returnMessage = returnMessage + '<br/> <span style="font-weight: bold">Accept สำเร็จ</span>'                                 
                                returnMessage = returnMessage + '<br/>เลขที่เอกสาร/MOM Doc No. : ' + response.data.t_HEADER.mom_no
                            } else if (response.data.t_PO_DETAIL.status === "WVER")  {     
                                returnMessage = returnMessage + '<br/> <span style="font-weight: bold">Submit สำเร็จ</span>'      
                                //returnMessage = returnMessage + '<br/>เลขที่เอกสาร/RRS Doc No. : ' + response.data.t_HEADER.doc_no                        
                                returnMessage = returnMessage + '<br/>เลขที่เอกสาร/MOM Doc No. : ' + response.data.t_HEADER.mom_no
                            }else { 
                                if (role === 'R' && response.data.t_PO_DETAIL.status === "WACCEPT" && status == "VERI"  ){
                                    window.$('#SubmitVerifyModal').modal('show');
                                    return
                                }
                                else {
                                    returnMessage = response.data.returnData.returnMessage
                                }
                            }

                            if (isSuccess) {
                                msg.success(returnMessage)
                                history.push(AppSettings.defaultUrl)
                            } else {
                                msg.error(returnMessage)
                            }
                        })
                    },
                    () => {
                        msg.hideConfirm()
                        console.log("On Cancel")
                    },
                    () => {
                        console.log("On Closed")
                    }
                )

            }
        }, 200)
        this.props.stopLoading()
    }

    async validateTags() {
        await this.props.startValidateTags()
        window.emitter.emit(START_VALIDATE_TAGS, '')

        const {
            tagErrors,
        } = await this.props

        const {
            t_GR_ITEM,
            t_GR_SERVICE,
            t_GR_SERVICELINE,
            t_GR_ITEM_ACCOUNT_ASSIGNMENT,
            t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT,
            t_PO_DETAIL,
            t_IR_ONE_TIME_VENDOR
        } = this.props

        let po_no = t_PO_DETAIL && t_PO_DETAIL.po_contract_no;

        let _check = this.checkAmount()
        if (_check !== null) {
            tagErrors.push(_check)
        }

        let _checkEval = this.checkEval()
        if (_checkEval !== null) {
            tagErrors.push(_checkEval)
        }

        let _checkFineOver = this.checkFineOver()
        if (_checkFineOver !== null) {
            tagErrors.push(_checkFineOver)
        }

        let _checCompleteDate = this.checkCompleteDate()
        if (_checCompleteDate !== null) {
            tagErrors.push(_checCompleteDate)
        }

        let _checkTotal = validateUtil.checkTotalReceiveVal(t_GR_SERVICE, t_GR_SERVICELINE)
        if (_checkTotal !== null) {
            tagErrors.push(_checkTotal)
        }

        let _checkQty = validateUtil.checkReceiveQty(t_GR_ITEM, t_GR_SERVICE, t_GR_SERVICELINE, po_no)
        if (_checkQty !== null) {
            tagErrors.push(_checkQty)
        }

        let _checkGoodsRecipient = validateUtil.checkGoodsRecipientVal(t_GR_ITEM)
        if (_checkGoodsRecipient !== null) {
            tagErrors.push(_checkGoodsRecipient)
        }

        const userrole = Storage.getRole()
        if (userrole === 'R') {
            let _checkDummyAssect = validateUtil.checkDummyAssect(t_GR_ITEM, t_GR_SERVICE, t_GR_SERVICELINE, t_GR_ITEM_ACCOUNT_ASSIGNMENT, t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT)
            if (_checkDummyAssect !== null) {
                tagErrors.push(_checkDummyAssect)
            }
        }

        let _checkSelectItem = validateUtil.checkSelectItem(t_GR_ITEM, t_GR_SERVICE, t_GR_SERVICELINE)
        if (_checkSelectItem !== null) {
            tagErrors.push(_checkSelectItem)
        }

        let _validatePeriodStartEnd = this.checkValidateContractPeriodStartEnd()
        if(_validatePeriodStartEnd !== null){
            tagErrors.push(_validatePeriodStartEnd)
        }

        let _checkIO = await this.checkIO()
        if (_checkIO !== null) {
            tagErrors.push(_checkIO)
        }

           
        let _validateIR = this.checkValidateIR()
        if (_validateIR !== null) {
            tagErrors.push(_validateIR)
        }

        return tagErrors
    }

    async handleValidate(event) {
        event.preventDefault()

        const tagErrors = await this.validateTags()

        setTimeout(function () {
            let error_messages = []
            if (tagErrors.length > 0) {
                tagErrors.forEach((error, index) => {
                    error && error_messages.push(error.error_message)
                })

                msg.error(error_messages.join('<br/>'))
            }
            else {
                msg.success('Validate success')
            }
        }, 200)
        this.props.stopLoading()
    }

    async  checkPoEndYear(po_contract_no){
        let result = await this.checkYearEndPo(po_contract_no);
        return result
    }
    async checkYearEndPo(po_contract_no){
        let error_Year = ""
        try {
            //const resp = await 
            
          await this.props.getYearEndPOList(po_contract_no).then((resp)=>{
                
                if (resp.data.response.length > 0 && resp.data.response[0].lock_status === "Y") {
                    
                    error_Year =  "หมายเลข PO/Contract: " + po_contract_no + " ถูก Lock ไม่สามารถใช้งานได้<br/>"
                }
            })

        } catch (error) {
            console.log("error ==> ", error)
            //error_Year = error + " " + error_Year + "ไม่สามารถตรวจสอบ หมายเลข PO/Contract: " + po_contract_no + " นี้ได้<br/>"
        }
        if (error_Year !== ""){
            return {error_message: error_Year}
        }
        return null;
    }

    async checkChangeCommittee(po_contract_no){
        let error_Year = ""
        try {
            //const resp = await 
            
          await this.props.getChangeCommitteeAll(po_contract_no).then((resp)=>{
              
            
                if (resp && resp.data.length > 0 && resp.data.filter(w=>w.approve_status!=="COMPLETE" && w.approve_status!=="REJECT").length) {
                    //error_Year =  "หมายเลข PO/Contract: " + po_contract_no + " ไม่สามารถใช้งานได้ เนื่องจากอยู่ระหว่างการขอแก้ คณะกรรมการ<br/>"
                    error_Year = "PO/Contract: " + po_contract_no + "  อยู่ระหว่างแก้ไขคณะกรรมการตรวจรับ ไม่สามารถ ทำรายการได้ <br/>"
                }
            })

        } catch (error) {
            console.log("error ==> ", error)
            error_Year = error + " " + error_Year + "ไม่สามารถตรวจสอบ หมายเลข PO/Contract: " + po_contract_no + " นี้ได้<br/>"
        }
        if (error_Year !== ""){
            return {error_message: error_Year}
        }
        return null;
    }

    checkVerrifyAccept(isAccept,isPoAccept) {
        const {
            t_PO_COMMITTEE,
        } = this.props
        
        if (isAccept!==true){
            return { error_message: "กรุณาเลือก ข้าพเจ้าได้ตรวจสอบและขอยืนยันว่า ข้อมูลที่บันทึกนี้เป็นไปตามมติการประชุมของ คณะกรรมการตรวจรับหรือผู้ตรวจรับพัสดุ/สินค้า ทุกประการ" }
        }
        return null
    }
    checkVerrifyCommitee(isAccept,isPoAccept) {
        const {
            t_PO_COMMITTEE,
        } = this.props
        
        if (isAccept===true){
            var countCommitteeApprove = t_PO_COMMITTEE.filter(committee => committee.approve_status === 'Y')
            var countCommitteeNotApprove = t_PO_COMMITTEE.filter(committee => committee.approve_status === 'N')
            if (countCommitteeNotApprove.length > 0 && isPoAccept === false ){
                return { error_message: "กรุณาเลือก ผู้มีอำนาจอนุมัติสั่งการให้รับสินค้า/พัสดุ เนี่องมีการอนุมัติตรวจรับไม่เป็นเอกฉันท์" }
            }
        }        
        // else {
        //     return { error_message: "กรุณาเลือก ข้าพเจ้าได้ตรวจสอบและขอยืนยัน ..." }
        // }
        return null
    }

    checkVerrifyCommiteeComplete(isAccept,isPoAccept) {
        const {
            t_PO_COMMITTEE,
        } = this.props
        
            var countCommitteeApprove = t_PO_COMMITTEE.filter(committee => committee.approve_status === 'Y')
            var countCommitteeNotApprove = t_PO_COMMITTEE.filter(committee => committee.approve_status === 'N')
            
            if (t_PO_COMMITTEE.length != (countCommitteeApprove.length  + countCommitteeNotApprove.length)){
                return { error_message: "กรุณาบันทึกผลการตรวจรับให้ครบถ้วน" }
            }

        return null
    }

    checkAmount() {
        const {
            t_GR_ITEM,
            t_GR_SERVICE,
            t_GR_SERVICELINE,
            t_IR_ITEM,
            t_IR_DETAIL,
            masterVats
        } = this.props
        let _amountItem = 0
        let _amountIr = 0
        let _checkIR = 0
        const role = Storage.getRole()
        let numeral = require('numeral');
        let errorMas = null;
        let list_ir_item = new Object();
        let list_gr_item = new Object();

        t_IR_DETAIL && t_IR_DETAIL.map((m) => {
            let sum = 0
            const items = t_IR_ITEM.filter(f => f.ir_detail_id === m.ir_detail_id)
            items && items.map((i, index) => {
                if (i.checked === "1") {
                    let vat = masterVats.find(f => f.value === i.tax_code) ? masterVats.find(f => f.value === i.tax_code).key1 : 0
                    let t = m.calculate_tax_flag === 1 ? (utilityHelper.parseFloat(numeral(i.amount).format('0,0.00')) * utilityHelper.parseFloat(vat)) : 0
                    sum += utilityHelper.parseFloat(numeral(i.amount).format('0,0.00')) + t

                }
            })
            if (m.calculate_tax_flag !== 1) {
                sum += m.tax_amount
            }

            if (numeral(m.amount).format('0.00') !== numeral(sum).format('0.00') && role !== "C") {
                _checkIR = "กรุณาตรวจสอบยอดจำนวนเงินรวมภาษีมูลค่าเพิ่ม (IR Balance) อีกครั้ง"
            }
        })
        if (_checkIR) {
            return { error_message: "กรุณาตรวจสอบยอดจำนวนเงินรวมภาษีมูลค่าเพิ่ม (IR Balance) อีกครั้ง" }
        }

        t_IR_ITEM && t_IR_ITEM.map((m, index) => {
            if (m.checked === "1") {
                _amountIr += numeral(m.amount).value()
                
                if(m.gr_receive_qty !== null && m.receive_qty !== null )
                {
                    let receive_qty=utilityHelper.parseFloat(numeral(m.receive_qty).format('0,0.000'))
                    if(!list_ir_item.hasOwnProperty(m.item_id)){
                        list_ir_item[m.item_id]=receive_qty
                    }
                    else{
                        list_ir_item[m.item_id]+=receive_qty
                    }
                }

                var checkItemIRGR = 1
                t_GR_ITEM && t_GR_ITEM.map((k, index) => {
                    if (k.checked === "1" && k.item_id === m.item_id) {
                        checkItemIRGR = 0
                    }
                })
                t_GR_SERVICE && t_GR_SERVICE.map((k, index) => {
                    if (k.checked === "1" && k.service_item_id === m.item_id) {
                        checkItemIRGR = 0
                    }
                })
                if(checkItemIRGR){
                    t_IR_DETAIL && t_IR_DETAIL.map((j) => {
                        if(m.ir_detail_id === j.ir_detail_id)
                        {
                            errorMas = errorMas == null ? "" : errorMas +"<br/>"
                            errorMas += "กรุณาตรวจสอบข้อมูล รายการ:"+m.item_text+" Invoic No: "+j.reference+" ไม่ได้ทำรายการรับสินค้า"
                        }
                    })
                }
            }
        })
        
        t_GR_ITEM && t_GR_ITEM.map((m, index) => {
            if (m.checked === "1") {

                if(m.per>1){
                    _amountItem += utilityHelper.parseFloat(numeral(
                        numeral(m.receive_qty).value()/numeral(m.per).value() * numeral(m.net_price).value()
                    ).format('0.00'))
                }
                else{
                    _amountItem += utilityHelper.parseFloat(numeral(
                        numeral(m.receive_qty).value() * numeral(m.net_price).value()
                    ).format('0.00'))
                }

                if( m.receive_qty !== null)
                {
                    let receive_qty=utilityHelper.parseFloat(numeral(m.receive_qty).format('0,0.000'))
                    if(!list_gr_item.hasOwnProperty(m.item_id)){
                        list_gr_item[m.item_id]=receive_qty
                    }
                    else{
                        list_gr_item[m.item_id]+=receive_qty
                    }
                }
            }
        })

        
        for (let key in list_gr_item){
            let _gr_qty = list_gr_item[key];
            let _ir_qty = list_ir_item[key];
            if(numeral(_gr_qty).format('0.000') !== numeral(_ir_qty).format('0.000'))
            {
                errorMas = "กรุณาตรวจสอบข้อมูล จำนวนรับสินค้า ไม่ตรงกับ จำนวนสินค้าใบแจ้งหนี้ (Received Qty)"
                break;
            }
        }

        t_GR_SERVICE && t_GR_SERVICE.map((m, index) => {
            let itmLine = t_GR_SERVICELINE.filter(f => f.service_item_no === m.service_item_no)
            itmLine && itmLine.map((itm, idx) => {
                if ((m.checked === "1" || m.checked === 1 || m.checked === true)  
                    && (itm.checked === "1" || itm.checked === 1 || itm.checked === true)) {
                    _amountItem += utilityHelper.parseFloat(numeral(
                        numeral(itm.receive_qty).value() * numeral(itm.gross_price).value()
                    ).format('0.00'))
                    
                }
            })
        })
 
        if (numeral(_amountIr).format('0.00') !== numeral(_amountItem).format('0.00') && role !== "C") {
            errorMas = errorMas == null ? "" : errorMas +"<br/>"
            errorMas += "กรุณาตรวจสอบข้อมูล มูลค่ารับสินค้า ไม่ตรงกับ มูลค่าใบแจ้งหนี้ (Amount)"
        }

        if(t_IR_DETAIL.length === 0)
        {
            errorMas = "กรุณาระบุบข้อมูล Invoice Receipt"
        }

        if(!errorMas)
            return null
        else
            return { error_message: errorMas }
    }

    checkEval() {
        const {
            t_MR_DETAIL,
            t_MR_VENDOR,
        } = this.props
        let _amountItem = 0
        let _amountIr = 0

        if (t_MR_DETAIL != null) {
            let item = t_MR_DETAIL.evaluation_type
            if (item != "no_evaluation") {
                if (t_MR_VENDOR && t_MR_VENDOR.length <= 0) {
                    return { error_message: "กรุณาเพิ่มการประเมิน" }
                }
            }
        }

        return null
    }

    checkFineOver() {

        const role = Storage.getRole()
        if (role === "R") {
            const {
                t_IR_ITEM,
                t_MR_DETAIL,

            } = this.props

            let _amountFine = 0
            let _amountIr = 0
            t_IR_ITEM && t_IR_ITEM.map((m, index) => {
                if (m.checked === "1") {
                    _amountIr += m.amount
                }
            })

            if (t_MR_DETAIL != null) {

                let penalty_amount = t_MR_DETAIL.penalty_amount == null || t_MR_DETAIL.penalty_amount == "" ? '0' : t_MR_DETAIL.penalty_amount.toString().replace(/,/g, '')
                let other_penalty_amount = t_MR_DETAIL.other_penalty_amount == null || t_MR_DETAIL.other_penalty_amount == "" ? '0' : t_MR_DETAIL.other_penalty_amount.toString().replace(/,/g, '')
                let retention_amount = t_MR_DETAIL.retention_amount == null || t_MR_DETAIL.retention_amount == "" ? '0' : t_MR_DETAIL.retention_amount.toString().replace(/,/g, '')

                _amountFine = parseFloat(penalty_amount) + parseFloat(other_penalty_amount) + parseFloat(retention_amount)
            }


            if (_amountFine > _amountIr) {
                return { error_message: "กรุณาตรวจสอบข้อมูล ผลรวมของค่าปรับไม่ควรเกินมูลค่าของใบ Invoice Receipt" }
            }
            else
                return null
        }
        return null
    }

    checkPeriodDate(t_GR_DETAIL) {

        let isError=false

        if (t_GR_DETAIL) {
             if (t_GR_DETAIL.period_start_date 
                && t_GR_DETAIL.period_end_date 
                && t_GR_DETAIL.period_start_date > t_GR_DETAIL.period_end_date) {
                    isError=true;
             }

         }

        if (isError)
            return { error_message: "ข้อมูล Period End มีค่ามากว่า Period Start กรุณาตรวจสอบข้อมูล" }
        else
            return null
    }

    checkCompleteDate() {
        const {
            t_IR_DETAIL,
            t_MR_DETAIL,
        } = this.props
        let ir_postingdate = null
        let mr_completedate = null
        let isError = false
        if (t_MR_DETAIL != null) {
            mr_completedate = t_MR_DETAIL.completed_date
        }

        t_IR_DETAIL && t_IR_DETAIL.map((m, index) => {
            ir_postingdate = m.posting_date
            if (mr_completedate > ir_postingdate) {

                isError = true;
                return

            }
        })

        if (isError)
            return { error_message: "วันที่ถูกต้องครบถ้วนไม่สามารถมากกว่าวันที่ใน Invoice Reciept" }
        else
            return null
    }

    async checkMatbatchflag(){

        const { t_GR_ITEM } = this.props
        let msgerror = ""

        await Promise.all(t_GR_ITEM && t_GR_ITEM.map(async (item) => {

            if ((item.checked === '1' || item.checked === 1 || item.checked === true) && item.material && item.plant) {
                
                var response = await getValidateMatBatchFlagAction(item.material, item.plant, '', '')
                const { data } = response
             
                if (data) {
                    if (data && data.length > 0) {
                        if (item.batch == "" || item.batch == null) {
                            msgerror = msgerror + "กรุณาระบุ Item " + item.item_no + " : Batch <br/>"
                        }
                        if (data[0].totaL_SHELF_LIFE == "0" || data[0].totaL_SHELF_LIFE == null) {
                            if (item.sled_bbd == "" || item.sled_bbd == null) {
                                msgerror = msgerror + "กรุณาระบุ Item " + item.item_no + " : SLED BBD <br/>"
                            }
                        }
                        else if (data[0].totaL_SHELF_LIFE != "0" || data[0].totaL_SHELF_LIFE != null) {
                            if (item.date_of_manufacture == "" || item.date_of_manufacture == null) {
                                msgerror = msgerror + "กรุณาระบุ Item " + item.item_no + " : Date of Manufacture <br/>"
                            }
                            
                        }
                    }
                }
            }
        }))

        if (msgerror !== "") {
            return { error_message: msgerror }
        }
        return null
    }

    async checkIOV2() {

        let listIO=[];
        let listCost=[];
        let listBudget=[];
        let numeral = require('numeral');
        const AddKey = function(list, key, value) {
            if(list[key]===undefined)
                list[key] = value
            else
                list[key] = list[key] + value
        }

        const { t_PO_DETAIL, t_GR_DETAIL, t_GR_ITEM, t_GR_ITEM_ACCOUNT_ASSIGNMENT, t_GR_SERVICE, t_GR_SERVICELINE, t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT } = this.props
        const po_no = t_PO_DETAIL.po_contract_no;
        const isContract = po_no.substr(0, 2) === "41" ? true : false;
        const isPOPlanGSP = po_no.substr(0, 3) === '322' || po_no.substr(0, 3) === '324'  ? true : false;

        // งานซื้อ
        t_GR_ITEM && t_GR_ITEM.filter(f => f.checked === "1" || f.checked === 1).map(async (it) => {
            let gtitem = t_GR_ITEM_ACCOUNT_ASSIGNMENT && t_GR_ITEM_ACCOUNT_ASSIGNMENT.filter(f => f.item_no + "" === it.item_no + "" && (f.acc_order != null && f.acc_order.length != 9))
            gtitem && gtitem.map((acc, index) => {
                let acc_order = acc.acc_order.replace(/^0+/, '');

                if(acc_order.length !== 9)
                    AddKey(listIO,acc_order,1)
                if(it.a === "F")
                    AddKey(listCost,acc.cost_center,1)
    
                let net_price = utilityHelper.parseFloat(it.net_price);
                let it_qty = utilityHelper.parseFloat(it.receive_qty);
                let quantity = utilityHelper.parseFloat(acc.quantity);
                let perce= utilityHelper.parseFloat(acc.perce);
                let amount = 0;
    
                if(it.distribution === null || it.distribution === ""){ //Single account assignment
                    amount = net_price * it_qty;
                }
                else if(it.distribution == "1"){ // Muti account assignment
                    amount = net_price * quantity;
                }
                else if(it.distribution == "2"){ // Muti account assignment
                    amount = (net_price * it_qty) * (perce/100.00)
                }
    
                if(acc_order.length === 9){
                    /**/
                }
                else if(isContract){
                    AddKey(listBudget,acc_order,amount)
                }
                else if(isPOPlanGSP){
                    if(acc_order !== acc.acc_order_original && acc.acc_order_original)
                    AddKey(listBudget,acc_order,amount)
                }
            })
        })
        // งานจ้าง
        t_GR_SERVICE && t_GR_SERVICE.filter(f => f.checked === "1" || f.checked === 1).map(async (it) => {
            t_GR_SERVICELINE && t_GR_SERVICELINE.filter(f => (f.checked === "1" || f.checked === 1 || f.checked === true) && f.service_item_no+ "" === it.service_item_no+ "").map(async (sl) => {
                let gtitem = t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT.filter(f => f.item_no+ "" === sl.service_item_no+ "" && f.service_line_no+ "" === sl.service_line_no+ "" && f.acc_order.length != 9)
                let isPOUnPlan = it.overall_limit > 0 ? true : false 
                gtitem && gtitem.map((acc, index) => {
                    let acc_order = acc.acc_order.replace(/^0+/, '');

                    if(acc_order.length !== 9)
                        AddKey(listIO,acc_order,1)
                    if(it.a === "F")
                        AddKey(listCost,acc.cost_center,1)
        
                    let gross_price = utilityHelper.parseFloat(sl.gross_price);
                    let qty = utilityHelper.parseFloat(sl.receive_qty);
                    let amount = gross_price * qty;
        
                    if(acc_order.length === 9){
                        /**/
                    }
                    else if(isContract){
                        AddKey(listBudget,acc_order,amount)
                    }
                    else if(isPOPlanGSP || isPOUnPlan){
                        if(acc_order !== acc.acc_order_original && acc.acc_order_original)
                        AddKey(listBudget,acc_order,amount)
                    }
                })
            })
        })

        let exch_rate = 1;
        if (t_PO_DETAIL.exch_rate) {
            exch_rate = utilityHelper.parseFloat(t_PO_DETAIL.exch_rate)
        }

        let error_IO="";
        let error_Budget="";
        let error_Cost="";

        let listAll = [];
        listCost && Object.keys(listCost).map(async (key) => {listAll.push({"listCost":key})})
        listIO && Object.keys(listIO).map(async (key) => {listAll.push({"listIO":key})})
        listBudget && Object.keys(listBudget).map(async (key) => {listAll.push({"listBudget":{"IO":key,"amount":listBudget[key]}})})
        
        await Promise.all(
            listAll && listAll.map(async (row) => {
                
                let key = Object.keys(row)[0];
                let value = row[key]
                if(key === "listCost"){
                    try {
                        const resp = await this.props.getCostCenterActive(value, 0, 1)
                        
                        if (resp.data && resp.data.isCheck===false) {
                            
                            error_Cost = error_Cost + "หมายเลข Cost Center " + value + " ไม่สามารถใช้ได้<br/>"
                        }
                    } catch (error) {
                        console.log(error)
                        error_Cost = error + " " + error_Cost + "ไม่สามารถตรวจสอบ หมายเลข Cost Center: " + value + " นี้ได้<br/>"
                    }
                }
                else if(key === "listIO"){
                    try {
                        const resp = await this.props.getIOActive(null, null, null, value, null, null, 0, 1)
                        
                        if (resp.data && resp.data.isCheck===false) {
                            
                            error_IO = error_IO + "หมายเลข IO: " + value + " ไม่สามารถใช้งานในการทำรับนี้<br/>"
                        }
                    } catch (error) {
                        console.log(error)
                        error_IO = error + " " + error_IO + "ไม่สามารถตรวจสอบ หมายเลข IO: " + value + " นี้ได้<br/>"
                    }
                }
                else if(key === "listBudget"){
                   
                        let amount = value["amount"]
                        let io = value["IO"]
                    try {
                        const resp = await this.props.getBudget(io)
                        if (resp.data) {
                            let budget = resp.data.budget
                            let amountPrice = utilityHelper.parseFloat(numeral(amount * exch_rate).format('0,0.00'))
                    
                            if (amountPrice > budget) {
                                if (budget < 0)
                                    budget = 0;
                                error_Budget = error_Budget + "งบประมาณของ IO " + io + " คงเหลือ " + numeral(budget).format('0,0.00') + " ไม่เพียงพอในการทำรับนี้ <br/>"
                            }
                        }
                    } catch (error) {
                        console.log(error)
                        error_Budget = error + " " + error_Budget + "ไม่สามารถตรวจสอบงบประมาณของ IO: " + io + " นี้ได้ <br/>"
                    }
                }
            }),
        )
        
        let error = error_IO !== "" ? error_IO +"<br/>" : "";
        error += error_Budget !== "" ? error_Budget +"<br/>" : "";
        error += error_Cost !== "" ? error_Cost +"<br/>" : "";
        if(error_IO === "" && error_Budget === "" && error_Cost === "" )
            return null;
        else
            return { error_message: error }

    }

    async checkIO() {
        let io = ""
        let ioActive = ""
        let cc = ""
        let lstIO = []
        let lstCC = []
        let numeral = require('numeral');
        const { t_PO_DETAIL, t_PO_COMMITTEE, t_GR_ITEM, t_GR_ITEM_ACCOUNT_ASSIGNMENT, t_GR_SERVICE, t_GR_SERVICELINE, t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT } = this.props
        const _po = t_PO_DETAIL.po_contract_no.substr(0, 2)
        const _poGSP = t_PO_DETAIL.po_contract_no.substr(0, 3)
    

        let _unplan = false;
        await t_GR_SERVICE && t_GR_SERVICE.map((m) => {
            if (m.checked + "" === "1" && m.overall_limit > 0)
                _unplan = true;
        })
        if (_po === "41" || _unplan || _poGSP === "322" || _poGSP === "324") {
            let userrole = Storage.getRole()
        
            t_GR_ITEM && t_GR_ITEM.map(async (m) => {
                if (m.checked + "" === "1") {
                    let gtitem = t_GR_ITEM_ACCOUNT_ASSIGNMENT.filter(f => f.item_no === m.item_no)
                    gtitem && gtitem.map((item, index) => {
                        if (item.acc_order) {
                            if (item.acc_order.length != 9)
                                lstIO.push(item.acc_order)
                        }
                        if (item.cost_center && m.a === "F") {
                            lstCC.push(item.cost_center)
                        }
                    })
                }
            })

            t_GR_SERVICELINE && t_GR_SERVICELINE.map(async (m) => {
                if (m.checked) {
                    let gtitem = t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT.filter(f => f.item_no === m.service_item_no && f.service_line_no + "" === m.service_line_no + "")
                    gtitem && gtitem.map((item, index) => {
                        if (item.acc_order) {
                            if (item.acc_order.length != 9)
                                lstIO.push(item.acc_order)
                        }
                        const svitm = t_GR_SERVICE.find(f => f.service_item_no + "" === m.service_item_no + "")
                        if (svitm) {
                            if (item.cost_center && svitm.a === "F") {
                                lstCC.push(item.cost_center)
                            }
                        }
                    })
                }
            })


            function dynamicSort(property) {
                var sortOrder = 1;
                if (property[0] === "-") {
                    sortOrder = -1;
                    property = property.substr(1);
                }
                return function (a, b) {
                    var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
                    return result * sortOrder;
                }
            }
            function onlyUnique(value, index, lstIO) {
                return lstIO.indexOf(value) === index;
            }
            lstIO = lstIO.filter(onlyUnique)
            lstCC = lstCC.filter(onlyUnique)

  

            //check Cost Center
            await Promise.all(lstCC && lstCC.map(async (c) => {
                const resp = await this.props.getCostCenter(c, 0, 1)
                if (!resp.data) {
                    cc = cc + "หมายเลข Cost Center " + c + " ไม่สามารถใช้ได้<br/>"
                }
            }))
            io = io + cc

            console.groupEnd()
            if (io !== "") {
                return { error_message: io }
            }
        }
        return null
    }

    async checkCheckStatusMergeMR(t_MR_DETAIL) {
        let mess;

        if(t_MR_DETAIL.ref_no && t_MR_DETAIL.ref_no != null && t_MR_DETAIL.ref_no != undefined){
            let result=await this.props.getMRPOStatus(t_MR_DETAIL.ref_no)
            result=result.data[0]
            if(result){
                if(result.status && result.status!="BCFM"){
                    mess="ไม่สามารถรวมรายการตรวจรับจัดหา (Merge MR)ได้ เนื่องจาก "+result.transaction_no+" (สถานะ"+result.document_name+") ยังอยู่ระหว่างดำเนินการ กรุณาตรวจสอบอีกครั้ง <br/>"
                }
            }

        }

        if(mess){
            return { error_message: mess }
        }
        return null;
    }

    checkValidateMR() {
        const userrole = Storage.getRole()
        let msgMR = ""
        const { t_HEADER,t_IR_DETAIL,t_MR_DETAIL,t_PO_COMMITTEE,t_PO_DETAIL,upload_files } = this.props
 
        if(t_MR_DETAIL.receiver_code === undefined || t_MR_DETAIL.receiver_code === "" || t_MR_DETAIL.receiver_code === null){
            msgMR = msgMR + "กรุณาระบุ ชื่อผู้รับงาน <br/>"
        }
        if(t_MR_DETAIL.approver_code === undefined || t_MR_DETAIL.approver_code === ""|| t_MR_DETAIL.approver_code === null){
            msgMR = msgMR + "กรุณาระบุ ผู้อนุมัติ <br/>"
        }
        if(t_MR_DETAIL.completed_date === undefined || t_MR_DETAIL.completed_date === ""|| t_MR_DETAIL.completed_date === null){
            msgMR = msgMR + "กรุณาระบุ วันที่ถูกต้องครบถ้วนเมื่อ <br/>"
        }
        if(t_MR_DETAIL.mom_date === undefined || t_MR_DETAIL.mom_date === ""|| t_MR_DETAIL.mom_date === null){
            msgMR = msgMR + "กรุณาระบุ ที่ประชุมมีมติวันที่ <br/>"
        }
        if(t_PO_DETAIL.po_approve_date === undefined || t_PO_DETAIL.po_approve_date === ""|| t_PO_DETAIL.po_approve_date === null){
            msgMR = msgMR + "กรุณาระบุ วันที่ลงนาม ใบสั่ง / หนังสือสนอง / สัญญา <br/>"
        }

        

        
        if(t_MR_DETAIL.completed_date !== undefined && t_MR_DETAIL.mom_date !== "" && t_MR_DETAIL.mom_date !== null &&
        t_MR_DETAIL.mom_date !== undefined && t_MR_DETAIL.completed_date !== "" && t_MR_DETAIL.completed_date !== null){
            if (t_MR_DETAIL.completed_date > t_MR_DETAIL.mom_date)
            {
                if(!(t_MR_DETAIL.ignore_complete_date_mode === 'all_ignore'))
                {
                    //listError = listError + "วันที่ส่งมอบถูกต้องครบถ้วน` จะต้องน้อยกว่าหรือเท่ากับ `วันที่มีมติประชุม <br/>"
                    msgMR = msgMR +  "วันที่ส่งมอบถูกต้องครบถ้วน จะต้องน้อยกว่าหรือเท่ากับ วันที่มีมติประชุม <br/>"
                }
                
            }
            if (t_PO_DETAIL.po_approve_date !== undefined  && t_PO_DETAIL.po_approve_date !== "" && t_PO_DETAIL.po_approve_date !== null ){
                if (t_PO_DETAIL.po_approve_date >= t_MR_DETAIL.completed_date)
                {
                    if(!(t_MR_DETAIL.ignore_complete_date_mode === 'all_ignore' || t_MR_DETAIL.ignore_complete_date_mode === 'ignore_po_approve_date'))
                    {
                        //listError = listError + "วันที่ส่งมอบถูกต้องครบถ้วน` จะต้องน้อยกว่าหรือเท่ากับ `วันที่มีมติประชุม <br/>"
                        msgMR = msgMR + "วันที่ลงนาม ใบสั่ง / หนังสือสนอง / สัญญา จะต้องน้อยกว่า วันที่ส่งมอบถูกต้องครบถ้วน <br/>"
                    }
                }
            }

            
        }

        if(t_MR_DETAIL.completed_date !== undefined && t_MR_DETAIL.completed_date !== "" && t_MR_DETAIL.completed_date !== null &&
        t_PO_DETAIL.po_approve_date !== undefined  && t_PO_DETAIL.po_approve_date !== "" && t_PO_DETAIL.po_approve_date !== null ){
        // 1. "วันที่ลงนาม ใบสั่ง / หนังสือสนอง / สัญญา" ต้องดักแจ้งเตือนกรณี ระบุวันที่มากว่าวันที่มีมติประชุม & วันที่ส่งมอบครบถ้วน @superwaan 
        if (t_PO_DETAIL.po_approve_date > t_MR_DETAIL.mom_date)
        {
            if(!(t_MR_DETAIL.ignore_complete_date_mode === 'all_ignore' || t_MR_DETAIL.ignore_complete_date_mode === 'ignore_po_approve_date'))
            {
                //listError = listError + "วันที่ส่งมอบถูกต้องครบถ้วน` จะต้องน้อยกว่าหรือเท่ากับ `วันที่มีมติประชุม <br/>"
                msgMR = msgMR +  "วันที่ลงนาม ใบสั่ง / หนังสือสนอง / สัญญา จะต้องน้อยกว่า วันที่มีมติประชุม <br/>"
            }
             
        }
   
    }

        if((t_MR_DETAIL.installment_no_mr === undefined || t_MR_DETAIL.installment_no_mr === ""|| t_MR_DETAIL.installment_no_mr === null)){
            // &&  t_MR_DETAIL.final_installment_flag !== true){
            msgMR = msgMR + "กรุณาระบุ งวดที่ <br/>"
        }

        let listNotApprove =  t_PO_COMMITTEE.filter(w=> w.approve_status==="N");
        let countNotApprove = listNotApprove.length;
        if (countNotApprove > 0)
        {
            let error_file = "";
            let error_comment ="";
            listNotApprove.forEach(item => {
                if(item.comment === undefined || item.comment === null || item.comment === "")
                {
                    error_comment = "กรุณาระบุ ความเห็นเพิ่มเติม ให้ครบถ้วน กรณี ไม่อนุมัติตรวจรับ<br/>"
                }
                if (upload_files.filter(w=>w.file_category === "A"+item.sequence).length <= 0)
                {
                    error_file = "กรุณาแนบไฟล์ แนบรายงานความเห็นแย้ง ให้ครบถ้วน กรณี ไม่อนุมัติตรวจรับ<br/>"
                }
            });
            if (error_comment !== ""){
                msgMR = msgMR + error_comment;
            }
            if (error_file !== ""){
                msgMR = msgMR + error_file;
            }
            if (t_MR_DETAIL.approve_order_name === undefined || t_MR_DETAIL.approve_order_name=== null || t_MR_DETAIL.approve_order_name=== "")
            {
                msgMR = msgMR + "กรุณาระบุ ข้อมูลอนุมัติสั่งการรับหรือไม่รับ ชื่อ-นามสกุล <br/>";
            }
            if (t_MR_DETAIL.approve_order_no === undefined || t_MR_DETAIL.approve_order_no=== null || t_MR_DETAIL.approve_order_no== "")
            {
                msgMR = msgMR + "กรุณาระบุ ข้อมูลอนุมัติสั่งการรับหรือไม่รับ ใบบันทึกเลขที่ <br/>";
            }
            if (t_MR_DETAIL.approve_order_no_date === undefined || t_MR_DETAIL.approve_order_no_date=== null || t_MR_DETAIL.approve_order_no_date== "")
            {
                msgMR = msgMR + "กรุณาระบุ ข้อมูลอนุมัติสั่งการรับหรือไม่รับ ลงวันที่ <br/>";
            }
            if (t_MR_DETAIL.approve_order_at_date === undefined || t_MR_DETAIL.approve_order_at_date=== null || t_MR_DETAIL.approve_order_at_date== "")
            {
                msgMR = msgMR + "กรุณาระบุ ข้อมูลอนุมัติสั่งการรับหรือไม่รับ วันที่ผู้มีอำนาจฯสั่งการ <br/>";
            }

            if(t_MR_DETAIL.approve_order_at_date !== undefined && t_MR_DETAIL.approve_order_at_date !== "" && t_MR_DETAIL.approve_order_at_date !== null &&
            t_MR_DETAIL.mom_date !== undefined  && t_MR_DETAIL.mom_date !== "" && t_MR_DETAIL.mom_date !== null ){
            if (moment(t_MR_DETAIL.approve_order_at_date).format('DD/MM/YYYY') < moment(t_MR_DETAIL.mom_date).format('DD/MM/YYYY'))
            {
                msgMR = msgMR +  "วันที่ผู้มีอำนาจฯสั่งการ จะต้องมากกว่าหรือเท่ากับ วันที่มีมติประชุม <br/>"
                 
            }
        }

            if(upload_files.filter(w=>w.file_category==="NA").length<=0){
                msgMR = msgMR + "กรุณาระบุ ข้อมูลอนุมัติสั่งการรับหรือไม่รับ แนบแบบฟอร์ม F-นจ.จบญ-0032 <br/>"
            }

        }



        if (t_MR_DETAIL.evaluation_type == "no_evaluation" 
        && (t_MR_DETAIL.reason_id == "" || t_MR_DETAIL.reason_id == null
        || t_MR_DETAIL.reason_id == 0)) {
            msgMR = msgMR + "กรุณาระบุ เหตุผล กรณี ไม่มีการประเมิน<br/>"
        }
        

        if(t_MR_DETAIL.delivery_exception_flag === undefined || t_MR_DETAIL.delivery_exception_flag === ""|| t_MR_DETAIL.delivery_exception_flag === null){
            msgMR = msgMR + "กรุณาเลือก ผลการส่งมอบ (ภายในกำหนด,ล่าช้ากว่ากำหนด) <br/>"
        }

        if (
            t_MR_DETAIL.delivery_exception_flag === "delay_time"
            //&& t_MR_DETAIL.penalty_result === "penalty"
        ) {
            if (!t_MR_DETAIL.delay_day_no || t_MR_DETAIL.delay_day_no == 0 || t_MR_DETAIL.delay_day_no == null || t_MR_DETAIL.delay_day_no == undefined)
            {t_MR_DETAIL.delay_day_no = 0}
                //msgMR = msgMR + "กรุณาระบุ วันที่ล่าช้ากว่ากำหนด <br/>"
            if (!t_MR_DETAIL.delay_remark || t_MR_DETAIL.delay_remark=="")
                msgMR = msgMR + "กรุณาระบุ เนื่องจาก <br/>"
            if (!t_MR_DETAIL.penalty_amount || t_MR_DETAIL.penalty_amount == 0)
            {t_MR_DETAIL.penalty_amount = 0}
                //msgMR = msgMR + "กรุณาระบุ คิดค่าปรับในอัตราวันละ <br/>"
            // if (!t_MR_DETAIL.penalty_doc_no || t_MR_DETAIL.penalty_doc_no == 0)
            //     msgMR = msgMR + "กรุณาระบุ แจ้งสงวนสิทธิ์การปรับแล้วตามหนังสือ เลขที่ <br/>"    
            // if (!t_MR_DETAIL.penalty_doc_date || t_MR_DETAIL.penalty_doc_date == 0)
            //     msgMR = msgMR + "กรุณาระบุ แจ้งสงวนสิทธิ์การปรับแล้วตามหนังสือ ลงวันที่ <br/>"
            if (t_HEADER.product_type && t_HEADER.product_type === "G")
            { 
            //if (!t_MR_DETAIL.no_penalty_notify_no ||  t_MR_DETAIL.no_penalty_notify_no === '')
            //msgMR = msgMR + "กรุณาระบุ ทั้งนี้ ปตท. ได้มีหนังสือแจ้งสิทธิ์การเรียกค่าปรับ เลขที่ <br/>"

            //if (!t_MR_DETAIL.no_penalty_notify_date)
                //msgMR = msgMR + "กรุณาระบุ ทั้งนี้ ปตท. ได้มีหนังสือแจ้งสิทธิ์การเรียกค่าปรับ ลงวันที่ <br/>"
            }
            //if(!t_MR_DETAIL.no_penalty_reserved_no || t_MR_DETAIL.no_penalty_reserved_no === '')
            //msgMR = msgMR + "กรุณาระบุ " + (t_HEADER.product_type==="G"?"และหนังสือแจ้งสงวนสิทธิ์การเรียกค่าปรับ":"ทั้งนี้ ปตท. ได้แจ้งหนังสือแจ้งสงวนสิทธิ์การเรียกค่าปรับ " ) + " เลขที่ <br/>"
            //if(!t_MR_DETAIL.no_penalty_reserved_date)
            //msgMR = msgMR + "กรุณาระบุ " + (t_HEADER.product_type==="G"?"และหนังสือแจ้งสงวนสิทธิ์การเรียกค่าปรับ":"ทั้งนี้ ปตท. ได้แจ้งหนังสือแจ้งสงวนสิทธิ์การเรียกค่าปรับ " ) + " ลงวันที่ <br/>"

        }
        if (t_MR_DETAIL.other_penalty_flag && t_MR_DETAIL.other_penalty_flag === true){
            if (!t_MR_DETAIL.other_penalty_amount || t_MR_DETAIL.other_penalty_amount === "0" || t_MR_DETAIL.other_penalty_amount === "0.00" || t_MR_DETAIL.other_penalty_amount === null || t_MR_DETAIL.other_penalty_amount === undefined )
                msgMR = msgMR + "กรุณาระบุ ค่าปรับอื่นๆ เป็นจำนวนเงิน <br/>"
            if (!t_MR_DETAIL.other_penalty_remark || t_MR_DETAIL.other_penalty_remark === "" )
                msgMR = msgMR + "กรุณาระบุ ค่าปรับอื่นๆ เนื่องจาก <br/>"
        }

        if (
            t_MR_DETAIL.delivery_exception_flag === "delay_time"
            && t_MR_DETAIL.penalty_result === "no_penalty"
        ) {
            if (!t_MR_DETAIL.no_penalty_approve_no || t_MR_DETAIL.no_penalty_approve_no ==='')
            msgMR = msgMR + "กรุณาระบุ ลด / งด / ยกเว้นค่าปรับ ตามหนังสืออนุมัติ เลขที่ <br/>"
            if (!t_MR_DETAIL.no_penalty_approve_date || t_MR_DETAIL.no_penalty_approve_date ==='')
            msgMR = msgMR + "กรุณาระบุ ลด / งด / ยกเว้นค่าปรับ ตามหนังสืออนุมัติ ลงวันที่ <br/>"

            if (t_HEADER.product_type && t_HEADER.product_type === "G")
            {  
            //if ((!t_MR_DETAIL.no_penalty_notify_no ||  t_MR_DETAIL.no_penalty_notify_no === '') )
                //msgMR = msgMR + "กรุณาระบุ ทั้งนี้ ปตท. ได้มีหนังสือแจ้งสิทธิ์การเรียกค่าปรับ เลขที่ <br/>"

            //if (!t_MR_DETAIL.no_penalty_notify_date )
                //msgMR = msgMR + "กรุณาระบุ ทั้งนี้ ปตท. ได้มีหนังสือแจ้งสิทธิ์การเรียกค่าปรับ ลงวันที่ <br/>"
            }
            //if(!t_MR_DETAIL.no_penalty_reserved_no || t_MR_DETAIL.no_penalty_reserved_no === '')
                //msgMR = msgMR + "กรุณาระบุ " + (t_HEADER.product_type==="G"?"และหนังสือแจ้งสงวนสิทธิ์การเรียกค่าปรับ":"ทั้งนี้ ปตท. ได้แจ้งหนังสือแจ้งสงวนสิทธิ์การเรียกค่าปรับ " ) + " เลขที่ <br/>"
            //if(!t_MR_DETAIL.no_penalty_reserved_date)
                //msgMR = msgMR + "กรุณาระบุ " + (t_HEADER.product_type==="G"?"และหนังสือแจ้งสงวนสิทธิ์การเรียกค่าปรับ":"ทั้งนี้ ปตท. ได้แจ้งหนังสือแจ้งสงวนสิทธิ์การเรียกค่าปรับ " ) + " ลงวันที่ <br/>"

        }

        if(t_MR_DETAIL.retention_flag && t_MR_DETAIL.retention_flag === true){
            if(!t_MR_DETAIL.retention_amount || t_MR_DETAIL.retention_amount === "" || t_MR_DETAIL.retention_amount === "0" || t_MR_DETAIL.retention_amount === "0.00")
                msgMR = msgMR + "กรุณาระบุ Retention เป็นจำนวนเงิน <br/>"
            if(!t_MR_DETAIL.retention_remark || t_MR_DETAIL.retention_remark === "")
                msgMR = msgMR + "กรุณาระบุ Retention เนื่องจาก <br/>"
        }

        if(t_MR_DETAIL.advance_payment_flag && t_MR_DETAIL.advance_payment_flag === true){
            if(!t_MR_DETAIL.advance_payment_amount || t_MR_DETAIL.advance_payment_amount === "" || t_MR_DETAIL.advance_payment_amount === "0" || t_MR_DETAIL.advance_payment_amount === "0.00")
                msgMR = msgMR + "กรุณาระบุ Advance Payment เป็นจำนวนเงิน <br/>"
            if(!t_MR_DETAIL.advance_payment_remark || t_MR_DETAIL.advance_payment_remark === "")
                msgMR = msgMR + "กรุณาระบุ Advance Payment เนื่องจาก <br/>"
        }

        if(t_MR_DETAIL.down_dept_flag && t_MR_DETAIL.down_dept_flag === true){
            if(!t_MR_DETAIL.down_dept_amount || t_MR_DETAIL.down_dept_amount === "" || t_MR_DETAIL.down_dept_amount === "0" || t_MR_DETAIL.down_dept_amount === "0.00")
                msgMR = msgMR + "กรุณาระบุ ใบลดหนี้ เป็นจำนวนเงิน <br/>"          
            if(!t_MR_DETAIL.down_dept_period || t_MR_DETAIL.down_dept_period === "")
                msgMR = msgMR + "กรุณาระบุ ใบลดหนี้ งวดที่ <br/>"
            if(!t_MR_DETAIL.down_dept_no || t_MR_DETAIL.down_dept_no === "")
                msgMR = msgMR + "กรุณาระบุ ใบลดหนี้ เลขที่ <br/>"

            if(!t_MR_DETAIL.down_dept_date || t_MR_DETAIL.down_dept_date === "")
                msgMR = msgMR + "กรุณาระบุ ใบลดหนี้ ลงวันที่ <br/>"
        }
        
        if(t_MR_DETAIL.up_dept_flag && t_MR_DETAIL.up_dept_flag === true){
            if(!t_MR_DETAIL.up_dept_amount || t_MR_DETAIL.up_dept_amount === "" || t_MR_DETAIL.up_dept_amount === "0" || t_MR_DETAIL.up_dept_amount === "0.00")
                msgMR = msgMR + "กรุณาระบุ เพิ่มหนี้ เป็นจำนวนเงิน <br/>"          
            if(!t_MR_DETAIL.up_dept_period || t_MR_DETAIL.up_dept_period === "")
                msgMR = msgMR + "กรุณาระบุ เพิ่มหนี้ งวดที่ <br/>"
            if(!t_MR_DETAIL.up_dept_no || t_MR_DETAIL.up_dept_no === "")
                msgMR = msgMR + "กรุณาระบุ เพิ่มหนี้ เลขที่ <br/>"

            if(!t_MR_DETAIL.up_dept_date || t_MR_DETAIL.up_dept_date === "")
                msgMR = msgMR + "กรุณาระบุ เพิ่มหนี้ ลงวันที่ <br/>"
        }
        


        // else if(
        //     t_MR_DETAIL.delivery_exception_flag==="delay_time"
        //     && t_MR_DETAIL.penalty_result === "penalty"
        // )
        // {
        //     if(!t_MR_DETAIL.penalty_doc_no)
        //         msgMR = msgMR + "กรุณาระบุ แจ้งสงวนสิทธิ์การปรับแล้วตามหนังสือเลขที่ <br/>"
        //     if(!t_MR_DETAIL.penalty_doc_date)
        //         msgMR = msgMR + "กรุณาระบุ ลงวันที่ <br/>"
        // }

        let ir_postingdate = null
        let mr_completedate = null
        let isError = false
        

        mr_completedate = t_MR_DETAIL.completed_date
        

        t_IR_DETAIL && t_IR_DETAIL.map((m, index) => {
            ir_postingdate = m.posting_date
            if (mr_completedate > ir_postingdate) {
                isError = true;
            }
        })

        if (isError){
            if(!(t_MR_DETAIL.ignore_complete_date_mode === 'all_ignore' || t_MR_DETAIL.ignore_complete_date_mode === 'ignore_po_approve_date'))
            {
                msgMR = msgMR + "กรุณาตรวจสอบข้อมูล วันที่ถูกต้องครบถ้วนไม่สามารถมากกว่าวันที่ใน Invoice Reciept <br/>"
            }
        }

        if (msgMR) {
            return { error_message: msgMR }
        }

        return null
    }

    checkValidateIR() {
        const userrole = Storage.getRole()
        let msg = ""
        let index=1;
        // const { t_PO_DETAIL, t_IR_DETAIL, t_MR_DETAIL, t_IR_ONE_TIME_VENDOR } = this.props
        // t_IR_DETAIL && t_IR_DETAIL.map((e) => {
        //     if (!e.invoice_date) {
        //         msg = msg + "IR Data No."+index+" กรุณาระบุ Invoice Date <br/>"
        //     }
        //     if (!e.reference) {
        //         msg = msg + "IR Data No."+index+" กรุณาระบุ Reference <br/>"
        //     }
        //     if (!e.posting_date) {
        //         msg = msg + "IR Data No."+index+" กรุณาระบุ Posting Date <br/>"
        //     }
        //     if (!e.baseline_date) {
        //         msg = msg + "IR Data No."+index+" กรุณาระบุ BaselineDT <br/>"
        //     }
        //     if (!e.payt_terms) {
        //         msg = msg + "IR Data No."+index+" กรุณาระบุ Payt Terms <br/>"
        //     }
        //     if (!e.ir_text) {
        //         msg = msg + "IR Data No."+index+" กรุณาระบุ Text <br/>"
        //     }
        //     if (!e.amount) {
        //         msg = msg + "IR Data No."+index+" กรุณาระบุ Amount <br/>"
        //     }
        //     if (!e.tax_type) {
        //         msg = msg + "IR Data No."+index+" กรุณาระบุ Tax Type <br/>"
        //     }
        //     if (!e.bus_place) {
        //         msg = msg + "IR Data No."+index+" กรุณาระบุ Bus.place <br/>"
        //     }
        //     index++;
        // })

        
        // if (!t_IR_ONE_TIME_VENDOR.ot_tax_number3 && (t_PO_DETAIL.vendor_code != null && t_PO_DETAIL.vendor_code.indexOf("PXND") >= 0)) {
        //     msg = msg + "Popup เพิ่มรายละเอียดข้อมูลผู้ค้า กรุณาระบุ เลขที่ประจำตัวผู้เสียภาษี <br/>"
        // }

        // if (msg && userrole === "R") {
        //     return { error_message: msg }
        // }
        

        return null
    }

    checkValidateContractPeriodStartEnd() {

        let msg = ""
        const { t_HEADER, t_PO_DETAIL } = this.props
        const _po = t_PO_DETAIL.po_contract_no.substr(0, 2)
        
        if (_po === "41") {
            if (t_HEADER) {
                let systemdate = utilityHelper.parseFloat(moment(new Date()).format('YYYYMMDD')) //moment(new Date()).format('DD/MM/YYYY')
                let startdate = utilityHelper.parseFloat(moment(t_HEADER.contract_Period_Start).format('YYYYMMDD'))
                let enddate = utilityHelper.parseFloat(moment(t_HEADER.contract_Period_End).format('YYYYMMDD'))


                if (startdate && enddate && (startdate > systemdate || systemdate > enddate)) {
                    msg = msg + "Contract สามารถใช้ได้ในช่วงวันที่ " + moment(t_HEADER.contract_Period_Start).format('DD/MM/YYYY') + " - " + moment(t_HEADER.contract_Period_End).format('DD/MM/YYYY') + " กรุณาตรวจสอบข้อมูล "
                }
                else if (startdate && startdate > systemdate) {
                    msg = msg + "Contract สามารถใช้ได้ตั้งแต่วันที่ " + moment(t_HEADER.contract_Period_Start).format('DD/MM/YYYY') + " กรุณาตรวจสอบข้อมูล "
                }
                else if (enddate && systemdate > enddate) {
                    msg = msg + "Contract สามารถใช้ได้ถึงวันที่ " + moment(t_HEADER.contract_Period_End).format('DD/MM/YYYY') + " กรุณาตรวจสอบข้อมูล "
                }
            }
        }

        if (msg) {
            return { error_message: msg }
        }
        return null
    }

    async validateAllTab(tabName,isAccept,isPoAccept) {
        const user = Storage.getUser()
        const role = Storage.getRole()
        const {
             t_GR_ITEM,
            t_GR_SERVICE,
             t_GR_SERVICELINE,
             t_GR_ITEM_ACCOUNT_ASSIGNMENT,
             t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT,
            t_PO_DETAIL,
             t_IR_ONE_TIME_VENDOR,
            t_HEADER,
             t_GR_DETAIL,
            t_MR_DETAIL,
            t_PO_COMMITTEE,
        } = this.props

  

        let po_no = t_PO_DETAIL && t_PO_DETAIL.po_contract_no;
        t_HEADER.doc_type = "NOTBOT";
        const transaction = this.getCurrentTransaction()

        let listError = validateUtil.checkRequiredData(tabName,transaction)

        if( tabName  === 'MO' || tabName === 'MOA'){

            validateUtil.addListError(listError
                ,'T_MR_DETAIL_MOM'
                ,validateUtil.checkCommiteeWithApprover(t_MR_DETAIL,t_PO_COMMITTEE)
            )

            validateUtil.addListError(listError
                ,"T_MR_DETAIL_MOM"
                ,await this.checkPoEndYear(po_no)
            )

            validateUtil.addListError(listError
                ,"T_MR_DETAIL_MOM"
                ,this.checkValidateMOM()
            )

            // validateUtil.addListError(listError
            //     ,"T_MR_DETAIL_MOM"
            //     ,this.checkValidateMR()
            // )
            // validateUtil.addListError(listError
            //     ,"T_MR_DETAIL_MOM"
            //     ,this.checkFineOver()//ผลรวมของค่าปรับ
            // )



            validateUtil.addListError(listError
                ,"T_MR_DETAIL_MOM"
                ,await this.checkChangeCommittee(po_no)
            )
        }
       
        if ( tabName=== 'MOA') {
            validateUtil.addListError(listError
                ,"T_MR_DETAIL_MOM"
                ,this.checkVerrifyCommiteeComplete(isAccept,isPoAccept)
            )
            validateUtil.addListError(listError
                ,"T_MR_DETAIL_MOM"
                ,this.checkVerrifyCommitee(isAccept,isPoAccept)
            )  
            validateUtil.addListError(listError
                ,"T_MR_DETAIL_MOM"
                ,this.checkVerrifyAccept(isAccept,isPoAccept)
            )          
            
            
         }

        
        return listError;
    }

    async validateMom(tabName,isAccept,isPoAccept) {
        const user = Storage.getUser()
        const role = Storage.getRole()
        const {
            t_GR_ITEM,
            t_GR_SERVICE,
            t_GR_SERVICELINE,
            t_GR_ITEM_ACCOUNT_ASSIGNMENT,
            t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT,
            t_PO_DETAIL,
            t_IR_ONE_TIME_VENDOR,
            t_HEADER,
            t_GR_DETAIL,
            t_MR_DETAIL,
            t_PO_COMMITTEE,
        } = this.props

     

        let po_no = t_PO_DETAIL && t_PO_DETAIL.po_contract_no;
        t_HEADER.doc_type = "NOTBOT";
        const transaction = this.getCurrentTransaction()
        let listError = validateUtil.checkRequiredData(tabName,transaction)

            validateUtil.addListError(listError
                ,'T_MR_DETAIL'
                ,validateUtil.checkCommiteeWithApprover(t_MR_DETAIL,t_PO_COMMITTEE)
            )
            validateUtil.addListError(listError
                ,"T_MR_DETAIL_MOM"
                ,await this.checkPoEndYear(po_no)
            )
            validateUtil.addListError(listError
                ,"T_MR_DETAIL_MOM"
                ,this.checkValidateMOM()
            )
            validateUtil.addListError(listError
                ,"T_MR_DETAIL_MOM"
                ,this.checkVerrifyCommiteeComplete(isAccept,isPoAccept)
            )
            validateUtil.addListError(listError
                ,"T_MR_DETAIL_MOM"
                ,this.checkVerrifyCommitee(isAccept,isPoAccept)
            )  
            validateUtil.addListError(listError
                ,"T_MR_DETAIL_MOM"
                ,this.checkVerrifyAccept(isAccept,isPoAccept)
            )                     
        return listError;
    }

    checkValidateMOM() {
        const userrole = Storage.getRole()
        let msgMR = ""
        const { t_HEADER,t_IR_DETAIL,t_MR_DETAIL,t_PO_DETAIL,t_PO_COMMITTEE,upload_files } = this.props
 
        if(t_MR_DETAIL.receiver_code === undefined || t_MR_DETAIL.receiver_code === "" || t_MR_DETAIL.receiver_code === null){
            msgMR = msgMR + "กรุณาระบุ ชื่อผู้รับงาน <br/>"
        }
        if(t_MR_DETAIL.approver_code === undefined || t_MR_DETAIL.approver_code === ""|| t_MR_DETAIL.approver_code === null){
            msgMR = msgMR + "กรุณาระบุ ผู้อนุมัติ <br/>"
        }

        if(t_MR_DETAIL.completed_date === undefined || t_MR_DETAIL.completed_date === ""|| t_MR_DETAIL.completed_date === null){
            msgMR = msgMR + "กรุณาระบุ วันที่ถูกต้องครบถ้วนเมื่อ <br/>"
        }
        if(t_MR_DETAIL.mom_date === undefined || t_MR_DETAIL.mom_date === ""|| t_MR_DETAIL.mom_date === null){
            msgMR = msgMR + "กรุณาระบุ ที่ประชุมมีมติวันที่ <br/>"
        }
        if(t_PO_DETAIL.po_approve_date === undefined || t_PO_DETAIL.po_approve_date === ""|| t_PO_DETAIL.po_approve_date === null){
            msgMR = msgMR + "กรุณาระบุ วันที่ลงนาม ใบสั่ง / หนังสือสนอง / สัญญา <br/>"
        }

        if(t_MR_DETAIL.completed_date !== undefined && t_MR_DETAIL.mom_date !== "" && t_MR_DETAIL.mom_date !== null &&
        t_MR_DETAIL.mom_date !== undefined && t_MR_DETAIL.completed_date !== "" && t_MR_DETAIL.completed_date !== null){
            if (t_MR_DETAIL.completed_date > t_MR_DETAIL.mom_date)
            {
                if(!(t_MR_DETAIL.ignore_complete_date_mode === 'all_ignore'))
                {
                    //listError = listError + "วันที่ส่งมอบถูกต้องครบถ้วน` จะต้องน้อยกว่าหรือเท่ากับ `วันที่มีมติประชุม <br/>"
                    msgMR = msgMR +  "วันที่ส่งมอบถูกต้องครบถ้วน จะต้องน้อยกว่าหรือเท่ากับ วันที่มีมติประชุม <br/>"
                }
            }

            if (t_PO_DETAIL.po_approve_date !== undefined  && t_PO_DETAIL.po_approve_date !== "" && t_PO_DETAIL.po_approve_date !== null ){
                if (t_PO_DETAIL.po_approve_date >= t_MR_DETAIL.completed_date)
                {
                    if(!(t_MR_DETAIL.ignore_complete_date_mode === 'all_ignore' || t_MR_DETAIL.ignore_complete_date_mode === 'ignore_po_approve_date'))
                    {
                        //listError = listError + "วันที่ส่งมอบถูกต้องครบถ้วน` จะต้องน้อยกว่าหรือเท่ากับ `วันที่มีมติประชุม <br/>"
                        msgMR = msgMR + "วันที่ลงนาม ใบสั่ง / หนังสือสนอง / สัญญา จะต้องน้อยกว่า วันที่ส่งมอบถูกต้องครบถ้วน <br/>"
                    }
                }
            }
            

            
        }

     
        if(t_MR_DETAIL.completed_date !== undefined && t_MR_DETAIL.completed_date !== "" && t_MR_DETAIL.completed_date !== null &&
        t_PO_DETAIL.po_approve_date !== undefined  && t_PO_DETAIL.po_approve_date !== "" && t_PO_DETAIL.po_approve_date !== null ){
        // 1. "วันที่ลงนาม ใบสั่ง / หนังสือสนอง / สัญญา" ต้องดักแจ้งเตือนกรณี ระบุวันที่มากว่าวันที่มีมติประชุม & วันที่ส่งมอบครบถ้วน @superwaan 
        if (t_PO_DETAIL.po_approve_date > t_MR_DETAIL.mom_date)
        {
            if(!(t_MR_DETAIL.ignore_complete_date_mode === 'all_ignore' || t_MR_DETAIL.ignore_complete_date_mode === 'ignore_po_approve_date'))
            {
                //listError = listError + "วันที่ส่งมอบถูกต้องครบถ้วน` จะต้องน้อยกว่าหรือเท่ากับ `วันที่มีมติประชุม <br/>"
                msgMR = msgMR +  "วันที่ลงนาม ใบสั่ง / หนังสือสนอง / สัญญา จะต้องน้อยกว่า วันที่มีมติประชุม <br/>"
            }
             
        }
   
    }

        if((t_MR_DETAIL.installment_no_mr === undefined || t_MR_DETAIL.installment_no_mr === ""|| t_MR_DETAIL.installment_no_mr === null)) { 
            //&&  t_MR_DETAIL.final_installment_flag !== true){
            msgMR = msgMR + "กรุณาระบุ งวดที่ <br/>"
        }


        let listNotApprove =  t_PO_COMMITTEE.filter(w=> w.approve_status==="N");
        let countNotApprove = listNotApprove.length;
        if (countNotApprove > 0)
        {
            let error_file = "";
            let error_comment ="";
            listNotApprove.forEach(item => {
                if(item.comment === undefined || item.comment === null || item.comment === "")
                {
                    error_comment = "กรุณาระบุ ความเห็นเพิ่มเติม ให้ครบถ้วน กรณี ไม่อนุมัติตรวจรับ<br/>"
                }
                if (upload_files.filter(w=>w.file_category === "A"+item.sequence).length <= 0)
                {
                    error_file = "กรุณาแนบไฟล์ แนบรายงานความเห็นแย้ง ให้ครบถ้วน<br/>"
                }
                
            });
            if (error_comment !== ""){
                msgMR = msgMR + error_comment;
            }
            if (error_file !== ""){
                msgMR = msgMR + error_file;
            }
            if (t_MR_DETAIL.approve_order_name === undefined || t_MR_DETAIL.approve_order_name=== null || t_MR_DETAIL.approve_order_name=== "")
            {
                msgMR = msgMR + "กรุณาระบุ ข้อมูลอนุมัติสั่งการรับหรือไม่รับ ชื่อ-นามสกุล <br/>";
            }
            if (t_MR_DETAIL.approve_order_no === undefined || t_MR_DETAIL.approve_order_no=== null || t_MR_DETAIL.approve_order_no== "")
            {
                msgMR = msgMR + "กรุณาระบุ ข้อมูลอนุมัติสั่งการรับหรือไม่รับ ใบบันทึกเลขที่ <br/>";
            }
            if (t_MR_DETAIL.approve_order_no_date === undefined || t_MR_DETAIL.approve_order_no_date=== null || t_MR_DETAIL.approve_order_no_date== "")
            {
                msgMR = msgMR + "กรุณาระบุ ข้อมูลอนุมัติสั่งการรับหรือไม่รับ ลงวันที่ <br/>";
            }
            if (t_MR_DETAIL.approve_order_at_date === undefined || t_MR_DETAIL.approve_order_at_date=== null || t_MR_DETAIL.approve_order_at_date== "")
            {
                msgMR = msgMR + "กรุณาระบุ ข้อมูลอนุมัติสั่งการรับหรือไม่รับ วันที่ผู้มีอำนาจฯสั่งการ <br/>";
            }

            if(t_MR_DETAIL.approve_order_at_date !== undefined && t_MR_DETAIL.approve_order_at_date !== "" && t_MR_DETAIL.approve_order_at_date !== null &&
            t_MR_DETAIL.mom_date !== undefined  && t_MR_DETAIL.mom_date !== "" && t_MR_DETAIL.mom_date !== null ){

                if (moment(t_MR_DETAIL.approve_order_at_date).format('DD/MM/YYYY') < moment(t_MR_DETAIL.mom_date).format('DD/MM/YYYY'))
            {
                msgMR = msgMR +  "วันที่ผู้มีอำนาจฯสั่งการ จะต้องมากกว่าหรือเท่ากับ วันที่มีมติประชุม <br/>"
                 
            }
        }

            if(upload_files.filter(w=>w.file_category==="NA").length<=0){
                msgMR = msgMR + "กรุณาระบุ ข้อมูลอนุมัติสั่งการรับหรือไม่รับ แนบแบบฟอร์ม F-นจ.จบญ-0032 <br/>"
            }

        }


        // if (t_MR_DETAIL != null) {
        //     let item = t_MR_DETAIL.evaluation_type
        //     if (item == "no_evaluation" 
        //     && (t_MR_DETAIL.reason_id == "" || t_MR_DETAIL.reason_id == null
        //     || t_MR_DETAIL.reason_id == 0)) {
        //         //msgMR = msgMR + "กรุณาระบุ เหตุผล กรณี ไม่มีการประเมิน<br/>"
        //     }
        //     else if (item != "no_evaluation") {
        //         // if (t_MR_VENDOR && t_MR_VENDOR.length <= 0) {
        //         //     msgMR = msgMR + "กรุณาระบุ การประเมิน<br/>"
        //         // }
        //     }
        // }

        if(t_MR_DETAIL.delivery_exception_flag === undefined || t_MR_DETAIL.delivery_exception_flag === ""|| t_MR_DETAIL.delivery_exception_flag === null){
            msgMR = msgMR + "กรุณาเลือก ผลการส่งมอบ (ภายในกำหนด,ล่าช้ากว่ากำหนด) <br/>"
        }

        if (
            t_MR_DETAIL.delivery_exception_flag === "delay_time"
            //&& t_MR_DETAIL.penalty_result === "penalty"
        ) {
            if (!t_MR_DETAIL.delay_day_no || t_MR_DETAIL.delay_day_no == 0 || t_MR_DETAIL.delay_day_no == null || t_MR_DETAIL.delay_day_no == undefined)
            {t_MR_DETAIL.delay_day_no = 0}
            //msgMR = msgMR + "กรุณาระบุ วันที่ล่าช้ากว่ากำหนด <br/>"
            if (!t_MR_DETAIL.delay_remark || t_MR_DETAIL.delay_remark=="")
                msgMR = msgMR + "กรุณาระบุ เนื่องจาก <br/>"
            if (!t_MR_DETAIL.penalty_amount || t_MR_DETAIL.penalty_amount == 0 )
            {t_MR_DETAIL.penalty_amount = 0}
            //     msgMR = msgMR + "กรุณาระบุ คิดค่าปรับในอัตราวันละ <br/>"
            // if (!t_MR_DETAIL.penalty_doc_no || t_MR_DETAIL.penalty_doc_no == 0)
            //     msgMR = msgMR + "กรุณาระบุ แจ้งสงวนสิทธิ์การปรับแล้วตามหนังสือ เลขที่ <br/>"    
            // if (!t_MR_DETAIL.penalty_doc_date || t_MR_DETAIL.penalty_doc_date == 0)
            //     msgMR = msgMR + "กรุณาระบุ แจ้งสงวนสิทธิ์การปรับแล้วตามหนังสือ ลงวันที่ <br/>"
            if (t_HEADER.product_type && t_HEADER.product_type === "G")
            { 
                //if (!t_MR_DETAIL.no_penalty_notify_no ||  t_MR_DETAIL.no_penalty_notify_no === '')
                //msgMR = msgMR + "กรุณาระบุ ทั้งนี้ ปตท. ได้มีหนังสือแจ้งสิทธิ์การเรียกค่าปรับ เลขที่ <br/>"

                //if (!t_MR_DETAIL.no_penalty_notify_date)
                    //msgMR = msgMR + "กรุณาระบุ ทั้งนี้ ปตท. ได้มีหนังสือแจ้งสิทธิ์การเรียกค่าปรับ ลงวันที่ <br/>"
            }
            //if(!t_MR_DETAIL.no_penalty_reserved_no || t_MR_DETAIL.no_penalty_reserved_no === '')
            //msgMR = msgMR + "กรุณาระบุ " + (t_HEADER.product_type==="G"?"และหนังสือแจ้งสงวนสิทธิ์การเรียกค่าปรับ":"ทั้งนี้ ปตท. ได้แจ้งหนังสือแจ้งสงวนสิทธิ์การเรียกค่าปรับ " ) + " เลขที่ <br/>"
            //if(!t_MR_DETAIL.no_penalty_reserved_date)
            //msgMR = msgMR + "กรุณาระบุ " + (t_HEADER.product_type==="G"?"และหนังสือแจ้งสงวนสิทธิ์การเรียกค่าปรับ":"ทั้งนี้ ปตท. ได้แจ้งหนังสือแจ้งสงวนสิทธิ์การเรียกค่าปรับ " ) + " ลงวันที่ <br/>"

        
        }
        if (t_MR_DETAIL.other_penalty_flag && t_MR_DETAIL.other_penalty_flag === true){
            if (!t_MR_DETAIL.other_penalty_amount || t_MR_DETAIL.other_penalty_amount === "0" || t_MR_DETAIL.other_penalty_amount === "0.00" || t_MR_DETAIL.other_penalty_amount === null || t_MR_DETAIL.other_penalty_amount === undefined )
                msgMR = msgMR + "กรุณาระบุ ค่าปรับอื่นๆ เป็นจำนวนเงิน <br/>"
            if (!t_MR_DETAIL.other_penalty_remark || t_MR_DETAIL.other_penalty_remark === "" )
                msgMR = msgMR + "กรุณาระบุ ค่าปรับอื่นๆ เนื่องจาก <br/>"
        }

        if (
            t_MR_DETAIL.delivery_exception_flag === "delay_time"
            && t_MR_DETAIL.penalty_result === "no_penalty"
        ) {
            if (!t_MR_DETAIL.no_penalty_approve_no || t_MR_DETAIL.no_penalty_approve_no ==='')
            msgMR = msgMR + "กรุณาระบุ ลด / งด / ยกเว้นค่าปรับ ตามหนังสืออนุมัติ เลขที่ <br/>"
            if (!t_MR_DETAIL.no_penalty_approve_date || t_MR_DETAIL.no_penalty_approve_date ==='')
            msgMR = msgMR + "กรุณาระบุ ลด / งด / ยกเว้นค่าปรับ ตามหนังสืออนุมัติ ลงวันที่ <br/>"

            if (t_HEADER.product_type && t_HEADER.product_type === "G")
            {  
            //if (!t_MR_DETAIL.no_penalty_notify_no ||  t_MR_DETAIL.no_penalty_notify_no === '')
                //msgMR = msgMR + "กรุณาระบุ ทั้งนี้ ปตท. ได้มีหนังสือแจ้งสิทธิ์การเรียกค่าปรับ เลขที่ <br/>"
            //if (!t_MR_DETAIL.no_penalty_notify_date)
                //msgMR = msgMR + "กรุณาระบุ ทั้งนี้ ปตท. ได้มีหนังสือแจ้งสิทธิ์การเรียกค่าปรับ ลงวันที่ <br/>"
            }
            //if(!t_MR_DETAIL.no_penalty_reserved_no || t_MR_DETAIL.no_penalty_reserved_no === '')
                //msgMR = msgMR + "กรุณาระบุ " + (t_HEADER.product_type==="G"?"และหนังสือแจ้งสงวนสิทธิ์การเรียกค่าปรับ":"ทั้งนี้ ปตท. ได้แจ้งหนังสือแจ้งสงวนสิทธิ์การเรียกค่าปรับ " ) + " เลขที่ <br/>"
            //if(!t_MR_DETAIL.no_penalty_reserved_date)
                //msgMR = msgMR + "กรุณาระบุ " + (t_HEADER.product_type==="G"?"และหนังสือแจ้งสงวนสิทธิ์การเรียกค่าปรับ":"ทั้งนี้ ปตท. ได้แจ้งหนังสือแจ้งสงวนสิทธิ์การเรียกค่าปรับ " ) + " ลงวันที่ <br/>"

        }

        if(t_MR_DETAIL.retention_flag && t_MR_DETAIL.retention_flag === true){
            if(!t_MR_DETAIL.retention_amount || t_MR_DETAIL.retention_amount === "" || t_MR_DETAIL.retention_amount === "0" || t_MR_DETAIL.retention_amount === "0.00")
                msgMR = msgMR + "กรุณาระบุ Retention เป็นจำนวนเงิน <br/>"
            if(!t_MR_DETAIL.retention_remark || t_MR_DETAIL.retention_remark === "")
                msgMR = msgMR + "กรุณาระบุ Retention เนื่องจาก <br/>"
        }

        if(t_MR_DETAIL.advance_payment_flag && t_MR_DETAIL.advance_payment_flag === true){
            if(!t_MR_DETAIL.advance_payment_amount || t_MR_DETAIL.advance_payment_amount === "" || t_MR_DETAIL.advance_payment_amount === "0" || t_MR_DETAIL.advance_payment_amount === "0.00")
                msgMR = msgMR + "กรุณาระบุ Advance Payment เป็นจำนวนเงิน <br/>"
            if(!t_MR_DETAIL.advance_payment_remark || t_MR_DETAIL.advance_payment_remark === "")
                msgMR = msgMR + "กรุณาระบุ Advance Payment เนื่องจาก <br/>"
        }

        if(t_MR_DETAIL.down_dept_flag && t_MR_DETAIL.down_dept_flag === true){
            if(!t_MR_DETAIL.down_dept_amount || t_MR_DETAIL.down_dept_amount === "" || t_MR_DETAIL.down_dept_amount === "0" || t_MR_DETAIL.down_dept_amount === "0.00")
                msgMR = msgMR + "กรุณาระบุ ใบลดหนี้ เป็นจำนวนเงิน <br/>"          
            if(!t_MR_DETAIL.down_dept_period || t_MR_DETAIL.down_dept_period === "")
                msgMR = msgMR + "กรุณาระบุ ใบลดหนี้ งวดที่ <br/>"
            if(!t_MR_DETAIL.down_dept_no || t_MR_DETAIL.down_dept_no === "")
                msgMR = msgMR + "กรุณาระบุ ใบลดหนี้ เลขที่ <br/>"

            if(!t_MR_DETAIL.down_dept_date || t_MR_DETAIL.down_dept_date === "")
                msgMR = msgMR + "กรุณาระบุ ใบลดหนี้ ลงวันที่ <br/>"
        }
        
        if(t_MR_DETAIL.up_dept_flag && t_MR_DETAIL.up_dept_flag === true){
            if(!t_MR_DETAIL.up_dept_amount || t_MR_DETAIL.up_dept_amount === "" || t_MR_DETAIL.up_dept_amount === "0" || t_MR_DETAIL.up_dept_amount === "0.00")
                msgMR = msgMR + "กรุณาระบุ เพิ่มหนี้ เป็นจำนวนเงิน <br/>"          
            if(!t_MR_DETAIL.up_dept_period || t_MR_DETAIL.up_dept_period === "")
                msgMR = msgMR + "กรุณาระบุ เพิ่มหนี้ งวดที่ <br/>"
            if(!t_MR_DETAIL.up_dept_no || t_MR_DETAIL.up_dept_no === "")
                msgMR = msgMR + "กรุณาระบุ เพิ่มหนี้ เลขที่ <br/>"

            if(!t_MR_DETAIL.up_dept_date || t_MR_DETAIL.up_dept_date === "")
                msgMR = msgMR + "กรุณาระบุ เพิ่มหนี้ ลงวันที่ <br/>"
        }

       
        let ir_postingdate = null
        let mr_completedate = null
        let isError = false
        
        mr_completedate = t_MR_DETAIL.completed_date
        

        t_IR_DETAIL && t_IR_DETAIL.map((m, index) => {
            ir_postingdate = m.posting_date
            if (mr_completedate > ir_postingdate) {
                isError = true;
            }
        })

        if (isError){
            if(!(t_MR_DETAIL.ignore_complete_date_mode === 'all_ignore' || t_MR_DETAIL.ignore_complete_date_mode === 'ignore_po_approve_date'))
            {
                msgMR = msgMR + "กรุณาตรวจสอบข้อมูล วันที่ถูกต้องครบถ้วนไม่สามารถมากกว่าวันที่ใน Invoice Reciept <br/>"
            }
        }

        if (msgMR) {
            return { error_message: msgMR }
        }

        return null
    }

    async setReceiverName(transaction){
        if(transaction.t_HEADER !== undefined){
            if(transaction.t_HEADER.running !== null)
            return transaction
        }

        // const {t_GR_ITEM,t_GR_DETAIL} = transaction
        let userID="";
        // t_GR_ITEM && t_GR_ITEM.map((item, index) => {
        //     if ((item.checked === "1" || item.checked === 1)
        //         && item.goods_recipient && item.goods_recipient.length === 6
        //         && userID === ""){
        //         userID = item.goods_recipient
        //     }
        // })

        // if(t_GR_DETAIL.prsp_intern !== null && userID===""){
        //     userID=t_GR_DETAIL.prsp_intern;
        // }

        // if(userID.length<5 || userID === transaction.t_MR_DETAIL.receiver_code)
        //     return transaction

        // let uerPIS = await getSearchDirectoryInfoAwaitAction(userID,"");
        // let userFull=""
        // if(uerPIS !== null && uerPIS.data !== undefined && uerPIS.data.length>0){
        //     userFull = uerPIS.data[0].iname + " " +uerPIS.data[0].employeeNameTH
        // }

        // if(userFull != ""){
        //     transaction.t_MR_DETAIL.receiver_code=userID
        //     transaction.t_MR_DETAIL.receiver_name=userFull
        // }

        return transaction
            
    }

    handleMrIrDesCroptionChange(trans) {
        let local_t_MR_IR_DESCRIPTIONS = []
        const { t_GR_DETAIL, t_GR_ITEM, t_GR_SERVICE, transaction, viewMode, transaction_no, t_MR_IR_DESCRIPTION } = trans
        local_t_MR_IR_DESCRIPTIONS = this.bindingMrIrDesCroption(t_GR_ITEM, t_GR_SERVICE, local_t_MR_IR_DESCRIPTIONS, transaction_no, t_GR_DETAIL, t_MR_IR_DESCRIPTION)
        this.props.updateMR_IrDescription(local_t_MR_IR_DESCRIPTIONS, "", "", true)
    }
    bindingMrIrDesCroption(t_GR_ITEM, t_GR_SERVICE, local_t_MR_IR_DESCRIPTION, transaction_no, t_GR_DETAIL, t_MR_IR_DESCRIPTION) {
        const grItems = t_GR_ITEM.filter(f => f.checked == 1);
        const grServices = t_GR_SERVICE.filter(f => f.checked == 1);
        let invoicDescription = ""
        if (grItems != null && grServices != null && grItems.length === 0 && grServices.length === 0) {
            local_t_MR_IR_DESCRIPTION = []
        } else {
            if (typeof grItems != "undefined" && grItems != null && grItems.length != null
                && grItems.length > 0) {
                let mrIrDesc = t_MR_IR_DESCRIPTION.find(f => f.item_id === null)
                if (mrIrDesc) {
                    invoicDescription = mrIrDesc.invoic_description
                } else {
                    invoicDescription = t_GR_DETAIL.delivery_note
                }
                local_t_MR_IR_DESCRIPTION.push({ running: 0, transaction_no: transaction_no, item_id: null, short_text: t_GR_DETAIL.po_header_text, invoic_description: invoicDescription })
            }
            if (typeof grServices != "undefined" && grServices != null && grServices.length != null
                && grServices.length > 0) {
                grServices.map((item, index) => {
                    let mrIrDesc = t_MR_IR_DESCRIPTION.find(f => f.item_id === item.service_item_id)
                    if (mrIrDesc) {
                        invoicDescription = mrIrDesc.invoic_description
                    } else {
                        invoicDescription = t_GR_DETAIL.reference
                    }
                    local_t_MR_IR_DESCRIPTION.push({ running: 0, transaction_no: item.transaction_no, item_id: item.service_item_id, short_text: item.short_text, invoic_description: invoicDescription })
                })
            }
        }
        return local_t_MR_IR_DESCRIPTION
    }
    
    async saveValidate(status = null,tabName,nexttab,isSumit,isAccept,isPoAccept) {
       
        this.props.startLoading()
        const user = Storage.getUser()
        const role = Storage.getRole()
        const {
            history,
            saveTransaction,
            sessionNo,
        } = await this.props
        const {
            t_GR_SERVICELINE,
            t_PO_DETAIL,
            t_MR_DETAIL,
            t_HEADER,
        } = this.props
      
        let listError = []
        t_HEADER.doc_type = "NOTBOT";
        if(status !=="Manualy"){
            if (isSumit === true && status !== "REJT" && status !== "ACCEPT")
            {
                listError = await this.validateAllTab(tabName,isAccept,isPoAccept);
            }
            else 
            {
                if ( status !== "REJT" && status !== "ACCEPT" ){
                    //listError = await this.validateMom(tabName,isAccept,isPoAccept);
                    if(t_MR_DETAIL.completed_date !== undefined && t_MR_DETAIL.mom_date !== "" && t_MR_DETAIL.mom_date !== null &&
                    t_MR_DETAIL.mom_date !== undefined && t_MR_DETAIL.completed_date !== "" && t_MR_DETAIL.completed_date !== null){
                        if (t_MR_DETAIL.completed_date > t_MR_DETAIL.mom_date)
                        {
                            if(!(t_MR_DETAIL.ignore_complete_date_mode === 'all_ignore'))
                            {
                                //listError = listError + "วันที่ส่งมอบถูกต้องครบถ้วน` จะต้องน้อยกว่าหรือเท่ากับ `วันที่มีมติประชุม <br/>"
                                validateUtil.addListError(listError
                                    ,"T_MR_DETAIL_MOM"
                                    ,{ error_message: "วันที่ส่งมอบถูกต้องครบถ้วน จะต้องน้อยกว่าหรือเท่ากับ วันที่มีมติประชุม <br/>"}
                                )  
                            }
                        }
        
                        if (t_PO_DETAIL.po_approve_date !== undefined  && t_PO_DETAIL.po_approve_date !== "" && t_MR_DETAIL.po_approve_date !== null ){
                            if (t_PO_DETAIL.po_approve_date >= t_MR_DETAIL.completed_date)
                            {
                                if(!(t_MR_DETAIL.ignore_complete_date_mode === 'all_ignore' || t_MR_DETAIL.ignore_complete_date_mode === 'ignore_po_approve_date'))
                                {
                                    //listError = listError + "วันที่ส่งมอบถูกต้องครบถ้วน` จะต้องน้อยกว่าหรือเท่ากับ `วันที่มีมติประชุม <br/>"
                                    validateUtil.addListError(listError
                                        ,"T_MR_DETAIL_MOM"
                                        ,{ error_message: "วันที่ลงนาม ใบสั่ง / หนังสือสนอง / สัญญา จะต้องน้อยกว่า วันที่ส่งมอบถูกต้องครบถ้วน <br/>"}
                                    )  
                                }
                            }
                        }

                        
                    }

                 
                    if(t_MR_DETAIL.completed_date !== undefined && t_MR_DETAIL.completed_date !== "" && t_MR_DETAIL.completed_date !== null &&
                    t_PO_DETAIL.po_approve_date !== undefined  && t_PO_DETAIL.po_approve_date !== "" && t_PO_DETAIL.po_approve_date !== null ){
                    // 1. "วันที่ลงนาม ใบสั่ง / หนังสือสนอง / สัญญา" ต้องดักแจ้งเตือนกรณี ระบุวันที่มากว่าวันที่มีมติประชุม & วันที่ส่งมอบครบถ้วน @superwaan 
                    if (t_PO_DETAIL.po_approve_date > t_MR_DETAIL.mom_date)
                    {
                        if(!(t_MR_DETAIL.ignore_complete_date_mode === 'all_ignore' || t_MR_DETAIL.ignore_complete_date_mode === 'ignore_po_approve_date'))
                        {
                            //listError = listError + "วันที่ส่งมอบถูกต้องครบถ้วน` จะต้องน้อยกว่าหรือเท่ากับ `วันที่มีมติประชุม <br/>"
                            validateUtil.addListError(listError
                                ,"T_MR_DETAIL_MOM"
                                ,{ error_message: "วันที่ลงนาม ใบสั่ง / หนังสือสนอง / สัญญา จะต้องน้อยกว่า วันที่มีมติประชุม <br/>"}
                            )  
                        }
                    }  

            
                    }
                    
                }
            }
            if(listError != null && listError.T_MR_DETAIL != null 
                && t_MR_DETAIL.ref_no != null && t_MR_DETAIL.ref_no.length > 0 
                && t_MR_DETAIL.ref_no.indexOf("T")!=-1){
                var arr = document.getElementsByName('ref_no'); //will be an array
                let rrsdoc_no=arr[0].options[arr[0].selectedIndex].innerText;

                rrsdoc_no = rrsdoc_no.substr(rrsdoc_no.indexOf(' '),rrsdoc_no.length);

                let mrMess="ตรวจสอบข้อมูลเอกสารตรวจรับ RRS Doc No. : "+rrsdoc_no;
                if(rrsdoc_no.indexOf("RRS")!=-1){
                    let listMRMess=[];
                    listMRMess.push(mrMess);
                    listError.T_MR_DETAIL.forEach(element => {
                        listMRMess.push(element)
                    });
                    listError.T_MR_DETAIL=listMRMess;
                }

            }
        }
        let transaction = this.getCurrentTransaction()
        if(!isSumit){
            if (Object.keys(listError).length === 0 && transaction.t_GR_DETAIL && transaction.t_GR_DETAIL.running===0){
                this.handleMrIrDesCroptionChange(transaction);
                transaction = this.getCurrentTransaction()
            }
            //transaction = await this.setReceiverName(transaction)
        }
        setTimeout(function () {

            if (Object.keys(listError).length > 0) {
                msg.warningSave(listError);
            } 
            else if(isSumit){
                saveTransaction(true, transaction, user.userName, role, status , null , sessionNo).then((response) => {

                    let isSuccess = response.data.returnData.isSuccess === true
                    //let returnMessage = response.data.returnData.returnMessage
                     let returnMessage = ""
                    if (status === "ACCEPT")  {           
                        // returnMessage = returnMessage + '<br/>เลขที่เอกสาร/MOM Doc No. : ' + response.data.t_HEADER.doc_no    
                        returnMessage = returnMessage + '<br/> <span style="font-weight: bold">Accept สำเร็จ</span>'                       
                        returnMessage = returnMessage + '<br/>เลขที่เอกสาร/MOM Doc No. : ' + response.data.t_HEADER.mom_no
                    } else if (response.data.t_PO_DETAIL.status === "WVER")  {     
                        returnMessage = returnMessage + '<br/> <span style="font-weight: bold">Submit สำเร็จ</span>'      
                        //returnMessage = returnMessage + '<br/>เลขที่เอกสาร/RRS Doc No. : ' + response.data.t_HEADER.doc_no                        
                        returnMessage = returnMessage + '<br/>เลขที่เอกสาร/MOM Doc No. : ' + response.data.t_HEADER.mom_no
                    }  else { 
                        
                        if (role === 'R' && response.data.t_PO_DETAIL.status === "WACCEPT" && status == "VERI"  ){
                            window.$('#SubmitVerifyModal').modal('show');
                            return
                        }
                        else {
                            returnMessage = response.data.returnData.returnMessage
                        }
                    }

                    if (isSuccess) {
                        msg.success(returnMessage)
                        history.push(AppSettings.defaultUrl)
                    } else {
                        msg.error(returnMessage)
                    }
                }).catch(error => {
                    console.log("saveTransaction error:")
                    console.log(error)
                    if (error.message.indexOf("timeout") > -1) {
                        msg.error("เชื่อมต่อ Server เกินกว่าเวลาที่กำหนด กรุณาตรวจสอบการเชื่อมต่อ")
                    }
                    else {
                        msg.error(error)
                    }
                })
                
            }
            else if(!isSumit){
                saveTransaction(false, transaction, user.userName, role, status, null, sessionNo).then((response) => {
                    const isSuccess = response.data.returnData.isSuccess === true
                    let returnMessage = response.data.returnData.returnMessage
                    const errMessage = response.data.returnData.errMessage
                    const poNo = response.data.t_PO_DETAIL.po_contract_no
                    const tranNo = response.data.returnData.transactionNo

                    returnMessage = returnMessage + '<br/>เลขที่เอกสาร/MOM Doc No. : ' + response.data.t_HEADER.mom_no

                    //this.props.stopLoading()
                    if (isSuccess) {
                        msg.success(returnMessage, nexttab)
                       //  window.onLoadServiceLineBySave(t_GR_SERVICELINE)
                        //  searchPO(poNo, tranNo, "save").then((response)=>{
                        //      window.onLoadServiceLineBySave(response.t_GR_SERVICELINE)
                        //  })
                       
                    } else {
                        msg.error(returnMessage)
                        if (errMessage) console.error("MainScreen.save()", errMessage)
                    }
                }).catch(error => {
                   
                    console.log("saveTransaction error:")
                    console.log(error)
                    if (error.message.indexOf("timeout") > -1) {
                        msg.error("เชื่อมต่อ Server เกินกว่าเวลาที่กำหนด กรุณาตรวจสอบการเชื่อมต่อ")
                    }
                    else {
                        msg.error(error)
                    }
                })
            }
        }, 200)
        this.props.stopLoading()
    }

    async handleSubmitMethodModal(event) {
        event.preventDefault()

        window.$('#SubmitMethodModal').modal('show');
        this.props.stopLoading()
    }

    async handleSubmitVerifyMethodModal(event) {
        event.preventDefault()

        window.$('#SubmitVerifyMethodModal').modal('show');
        this.props.stopLoading()
    }

    async handleOnClickToExtendConsiderationPeriodItem(url) {
        const {history} = this.props;
        history.push({
            pathname: url,
            params: ``,
        })
    }

    render() {
        console.log("MainScreen.render()")
        let { transaction_no, status, t_PO_DETAIL, t_HEADER ,t_PO_COMMITTEE} = this.props
        let {masterRejectOption} = this.state
        return (
            <div className="rrs">
                <IdleTimer
                    ref={ref => { this.idleTimer = ref }}
                    element={document}
                    onIdle={this.onIdle}
                    debounce={250}
                    timeout={this.pageTimeOut} />
                <SecureGateRoute />
                <div id="main-content">
                    <div className="page-body">
                        <BreadCrumb breadcrumb={[
                            {name: 'RRS Home',url:AppSettings.defaultUrl},
                            {name:'กรอกข้อมูลบันทึกรายงานประชุมการตรวจรับ (Mom) ในระบบ RRS เท่านั้น โดยหน่วยงานจัดหาจะบันทึก GR/IR ในระบบ SAP',url:''}
                        ]}></BreadCrumb>
                        <div className="sp-page-header-panel row">
                            <div className="col-md-12 sp-page-header">
                                <h1 className="sp-page-header1" style={{fontSize:26}}>กรอกข้อมูลบันทึกรายงานประชุมการตรวจรับ (Mom) ในระบบ RRS เท่านั้น โดยหน่วยงานจัดหาจะบันทึก GR/IR ในระบบ SAP </h1>
                            </div>
                        </div>

                        <StatusIndicator status={transaction_no ? status : null} rrsdoc={t_HEADER ? t_HEADER.doc_no : null} poNo={t_PO_DETAIL ? t_PO_DETAIL.po_contract_no : null} />

                        <div id="invoiceRecordingSystem" className="rrs-wrapper">
                            <MainNotBotTabMenu />
                            {/* Tab 1 */}
                            <PODetail
                                onSearchPO={(po) => { this.searchPO(po, null, null) }}
                                status_data={this.state.status_data}
                            />
                            {/* Tab 2 */}
                            <MomDetail
                                tabName='MO'
                                docType = "NOTBOT"
                                status_data={this.state.status_data}
                                onHandleSubmit={this.handleSubmit}
                                onHandleDelete={this.handleDelete}
                                onConfirmModalMethod={this.handleSubmitMethodModal}
                                onConfirmVerifyMoalMethod = {this.handleSubmitVerifyMethodModal}
                                onClickToExtendConsiderationPeriodItem = {this.handleOnClickToExtendConsiderationPeriodItem}
                                // onValidateGR={this.validateMOM}
                            />
                            
                        </div>
                    </div>
                </div>
                <DocumentModal />

                <SearchEmployeeModal />
                <SearchCostCenterModal />
                {/* <OneTimeVendorModal /> */}
                <SubmitMethodModal
                    onHandleSubmit={this.handleSubmit}
                    tabName = "MOA"
                    is_accept = {false}
                    is_po_accept = {false}
                    //t_PO_COMMITTEE = {t_PO_COMMITTEE}
                />

                <SubmitVerifyMethodModal
                onHandleSubmit={this.handleSubmit}
                tabName = "MOA"
                is_accept = {false}
                is_po_accept = {false}          
                />
                <SubmitVerifyModal
                    onHandleSubmit={this.handleSubmitVerify}
                    tabName = "MOA"
                    is_accept = {false}
                    is_po_accept = {false}
                    doc_no = {t_HEADER.doc_no}
                    mom_no = {t_HEADER.mom_no}
                    transaction_no = {t_HEADER.transaction_no}
                    onHandleVerifySubmit ={this.onHandleVerifySubmit}
                    
                    //t_PO_COMMITTEE = {t_PO_COMMITTEE}
                />
                <RejectModal
                    onHandleReject={this.handleReject}                  
                />

                <RejectWithOptionModal
                    onHandleReject={this.handleRejectApprover}
                    RejectDataOption = {this.props.masterRejectOption}
                    tabName = "MOA"

                />

                <AddItemModal />
                <AddServiceItemModal />
                <ReleaseOrderModal/>
                <SearchPoModal
                onSearchPO={(po) => { this.searchPO(po, null, null) }}
                status_data={this.state.status_data}/>


                {/* backtotop button */}
                <div className="backtotop-panel">
                    <span className="bt-backtotop btn"  >
                        <i className="icon btn-order-top" onClick={() => window.scroll({ top: 0, behavior: 'smooth' })} />
                    </span>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const { AppRedux, MainRedux, MasterRedux,DocControlRedux,ApproveRedux,UploadRedux } = state
    
    return {
        transaction_no: MainRedux.transaction_no,
        temp_trans_att_no: MainRedux.temp_trans_att_no,
        status: MainRedux.status,
        vats: MasterRedux.vats,
        tagErrors: AppRedux.tagErrors,
        role: MainRedux.role,
        transaction: MainRedux.transaction,
        t_HEADER:MainRedux.t_HEADER,
        t_PO_DETAIL: MainRedux.t_PO_DETAIL,
        t_PO_COMMITTEE: MainRedux.t_PO_COMMITTEE,
        t_GR_DETAIL: MainRedux.t_GR_DETAIL,
        t_GR_ITEM: MainRedux.t_GR_ITEM,
        t_GR_ITEM_ACCOUNT_ASSIGNMENT: MainRedux.t_GR_ITEM_ACCOUNT_ASSIGNMENT,
        t_GR_SERVICE: MainRedux.t_GR_SERVICE,
        t_GR_SERVICELINE: MainRedux.t_GR_SERVICELINE,
        t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT: MainRedux.t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT,
        t_IR_DETAIL: MainRedux.t_IR_DETAIL,
        t_IR_ITEM: MainRedux.t_IR_ITEM,
        t_IR_TAXS: MainRedux.t_IR_TAXS,
        t_IR_ONE_TIME_VENDOR: MainRedux.t_IR_ONE_TIME_VENDOR,
        t_IR_ITEM_ACCOUNT_ASSIGNMENT: MainRedux.t_IR_ITEM_ACCOUNT_ASSIGNMENT,
        t_IR_SERVICELINE: MainRedux.t_IR_SERVICELINE,
        t_MR_DETAIL: MainRedux.t_MR_DETAIL,
        t_MR_VENDOR: MainRedux.t_MR_VENDOR,
        t_MR_ATTACHMENTS: MainRedux.t_MR_ATTACHMENTS,
        t_NEW_ASSET: MainRedux.t_NEW_ASSET,
        t_MR_EVAL: MainRedux.t_MR_EVAL,

        bankBranchs: MasterRedux.bankBranchs,
        regions: MasterRedux.regions,
        countries: MasterRedux.countries,
        bankNames: MasterRedux.bankNames,
        unit_uom: MasterRedux.unit_uom,
        payment_methods: MasterRedux.payment_methods,
        payment_supplements: MasterRedux.payment_supplements,
        payment_terms: MasterRedux.payment_terms,
        masterVats: MasterRedux.masterVats,
        masterRejectOption: MasterRedux.masterRejectOption,
        currency_codes: MasterRedux.currency_codes,
        mrForms: MasterRedux.mrForms,
        mrVendortypes: MasterRedux.mrVendortypes,
        mrReson: MasterRedux.mrReason,
        sessionNo : DocControlRedux.sessionNo,
        t_MR_IR_DESCRIPTION: MainRedux.t_MR_IR_DESCRIPTION,
        po_contract_no: DocControlRedux.po_contract_no,
       isAccept : ApproveRedux.isAccept,
        isPoAccept: ApproveRedux.isPoAccept,
        upload_files: UploadRedux.upload_files,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getPaymentMethod: () => dispatch(getPaymentMethodAction()),
        getPaymentSupplement: () => dispatch(getPaymentSupplementAction()),
        getPaymentTerm: () => dispatch(getPaymentTermAction()),
        // getPlantInfo: () => dispatch(getPlantInfoAction()),
        getVat: () => dispatch(getVatAction()),
        saveTransaction: (isSubmit, transaction, userCode, role, status, userName , sessionNo) => dispatch(saveTransactionAction(isSubmit, transaction, userCode, role, status , userName , sessionNo)),
        updateVerify: (transaction_no,message_to_committee) =>dispatch(updateVerifyAction(transaction_no,message_to_committee)),
        rejectTransaction: (transaction, Reject_Result, Reject_By,Reject_Option,Reject_Option_Desc) => dispatch(rejectTransactionAction(transaction, Reject_Result, Reject_By,Reject_Option,Reject_Option_Desc)),
        startValidateTags: () => dispatch(startValidateTagsAction()),
        addTagError: (tag) => dispatch(addTagErrorAction(tag)),
        clearPODetail: () => dispatch(clearPODetailAction()),
        clearFile: () => dispatch(clearFileAction()),
        getPODetail: (po_no, tranNo, unitCode, actiontype ,userId ,sessionNo ,userName ) => dispatch(getPODetailAction(po_no, tranNo, unitCode, actiontype, userId,sessionNo , userName)),
        getRegion: () => dispatch(getRegionAction()),
        getBankBranch: () => dispatch(getBankBranchAction()),
        getCountry: () => dispatch(getCountryAction()),
        getBankName: () => dispatch(getBankNameAction()),
        getMasterVat: () => dispatch(getMasterVatAction()),
        getMasterRejectOption: () => dispatch(getMasterRejectOptionAction()),
        getSloc_WithPlantList: (purOrg, plants) => dispatch(getSloc_WithPlantListAction(purOrg, plants)),
        getVatCurrencyCode: () => dispatch(getVatCurrencyCodeAction()),
        getMRForm: () => dispatch(getMRFormAction()),
        getMRVendorType: () => dispatch(getMRVendorTypeAction()),
        getMrRefList: (poNo, tranNo) => dispatch(getMrRefListAction(poNo, tranNo)),
        getMRPOStatus: (tranNo) => dispatch(getPOStatusAction(tranNo)),
        updateGR_Item: (data, index = "", fieldName = "", clear) => dispatch(updateGR_ItemAction(data, index, fieldName, clear)),
        updateGR_ItemAccountAssignment: (data, index = "", fieldName = "", clear) => dispatch(updateGR_ItemAccountAssignmentAction(data, index, fieldName, clear)),
        updateGR_Service: (data, index = "", fieldName = "", clear) => dispatch(updateGR_ServiceAction(data, index, fieldName, clear)),
        updateGR_ServiceLine: (data, index = "", fieldName = "", clear) => dispatch(updateGR_ServiceLineAction(data, index, fieldName, clear)),
        updateGR_ServiceAccountAssignment: (data, index = "", fieldName = "", clear) => dispatch(updateGR_ServiceAccountAssignmentAction(data, index, fieldName, clear)),
        updateStatus: (transaction_no, status, user) => dispatch(updateStatusAction(transaction_no, status, user)),
        getUOM: () => dispatch(getUOMAction()),
        getBusinessInformation: (requestType, fiscalYear, ioNo, planVersion) => dispatch(getBusinessInformationAction(requestType, fiscalYear, ioNo, planVersion)),
        getBudget: (ioNo) => dispatch(getBudgetAction(ioNo)),
        startLoading: () => dispatch(startLoadingAction()),
        stopLoading: () => dispatch(stopLoadingAction()),
        getCostCenter: (searchCostCenter, offset, limit) => dispatch(getCostCenterAction(searchCostCenter, offset, limit)),
        getIO: (auart, processingGrp, description, orderNumber, searchCostCenter, searchIo, offset, limit) => dispatch(getIOAction(auart, processingGrp, description, orderNumber, searchCostCenter, searchIo, offset, limit)),
        getCostCenterActive: (searchCostCenter, offset, limit) => dispatch(getCostCenterActiveAction(searchCostCenter, offset, limit)),
        getIOActive: (auart, processingGrp, description, orderNumber, searchCostCenter, searchIo, offset, limit) => dispatch(getIOActiveAction(auart, processingGrp, description, orderNumber, searchCostCenter, searchIo, offset, limit)),
        clearStatusTab: () => dispatch(clearStatusTabAction()),
        getSearchDirectoryInfo: (employeeCode, employeeName) => dispatch(getSearchDirectoryInfoAwaitAction(employeeCode, employeeName)),
        setLockPO:() => dispatch(setStatusLockPOAction()),
        setUnlockPO:() => dispatch(setStatusUnlockPOAction()),
        updateMR_IrDescription: (data, index = "", fieldName = "", clear = false) => dispatch(updateMR_IrDescriptionAction(data, index, fieldName, clear)),
        getMRResonNotEval: () => dispatch(getMRResonNotEvalAction()),
        clearSearchDirectoryInfo: () => dispatch(clearSearchDirectoryInfoAction()),
        clearModal: () => dispatch(clearModalAction()),
        getPo_ContarctAction:() => dispatch(getPo_ContarctAction()),
        getIsAccept:() => dispatch(getIsAcceptAction()),
        getIsPoAccept:() => dispatch(getIsPoAcceptAction()),
        getYearEndPOList : (po_contract_no) => dispatch(getYearEndPOListAction(po_contract_no)),
        getChangeCommitteeAll : (po_contract_no) => dispatch(getChangeCommitteeAllAction(po_contract_no)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MainNotbotScreen);